(function e(t,n,r){function s(o,u){if(!n[o]){if(!t[o]){var a=typeof require=="function"&&require;if(!u&&a)return a(o,!0);if(i)return i(o,!0);var f=new Error("Cannot find module '"+o+"'");throw f.code="MODULE_NOT_FOUND",f}var l=n[o]={exports:{}};t[o][0].call(l.exports,function(e){var n=t[o][1][e];return s(n?n:e)},l,l.exports,e,t,n,r)}return n[o].exports}var i=typeof require=="function"&&require;for(var o=0;o<r.length;o++)s(r[o]);return s})({1:[function(require,module,exports){
module.exports = function(strings) {
  if (typeof strings === 'string') strings = [strings]
  var exprs = [].slice.call(arguments,1)
  var parts = []
  for (var i = 0; i < strings.length-1; i++) {
    parts.push(strings[i], exprs[i] || '')
  }
  parts.push(strings[i])
  return parts.join('')
}

},{}],2:[function(require,module,exports){
/**
 * isMobile.js v0.4.0
 *
 * A simple library to detect Apple phones and tablets,
 * Android phones and tablets, other mobile devices (like blackberry, mini-opera and windows phone),
 * and any kind of seven inch device, via user agent sniffing.
 *
 * @author: Kai Mallea (kmallea@gmail.com)
 *
 * @license: http://creativecommons.org/publicdomain/zero/1.0/
 */
(function (global) {

    var apple_phone         = /iPhone/i,
        apple_ipod          = /iPod/i,
        apple_tablet        = /iPad/i,
        android_phone       = /(?=.*\bAndroid\b)(?=.*\bMobile\b)/i, // Match 'Android' AND 'Mobile'
        android_tablet      = /Android/i,
        amazon_phone        = /(?=.*\bAndroid\b)(?=.*\bSD4930UR\b)/i,
        amazon_tablet       = /(?=.*\bAndroid\b)(?=.*\b(?:KFOT|KFTT|KFJWI|KFJWA|KFSOWI|KFTHWI|KFTHWA|KFAPWI|KFAPWA|KFARWI|KFASWI|KFSAWI|KFSAWA)\b)/i,
        windows_phone       = /IEMobile/i,
        windows_tablet      = /(?=.*\bWindows\b)(?=.*\bARM\b)/i, // Match 'Windows' AND 'ARM'
        other_blackberry    = /BlackBerry/i,
        other_blackberry_10 = /BB10/i,
        other_opera         = /Opera Mini/i,
        other_chrome        = /(CriOS|Chrome)(?=.*\bMobile\b)/i,
        other_firefox       = /(?=.*\bFirefox\b)(?=.*\bMobile\b)/i, // Match 'Firefox' AND 'Mobile'
        seven_inch = new RegExp(
            '(?:' +         // Non-capturing group

            'Nexus 7' +     // Nexus 7

            '|' +           // OR

            'BNTV250' +     // B&N Nook Tablet 7 inch

            '|' +           // OR

            'Kindle Fire' + // Kindle Fire

            '|' +           // OR

            'Silk' +        // Kindle Fire, Silk Accelerated

            '|' +           // OR

            'GT-P1000' +    // Galaxy Tab 7 inch

            ')',            // End non-capturing group

            'i');           // Case-insensitive matching

    var match = function(regex, userAgent) {
        return regex.test(userAgent);
    };

    var IsMobileClass = function(userAgent) {
        var ua = userAgent || navigator.userAgent;

        // Facebook mobile app's integrated browser adds a bunch of strings that
        // match everything. Strip it out if it exists.
        var tmp = ua.split('[FBAN');
        if (typeof tmp[1] !== 'undefined') {
            ua = tmp[0];
        }

        // Twitter mobile app's integrated browser on iPad adds a "Twitter for
        // iPhone" string. Same probable happens on other tablet platforms.
        // This will confuse detection so strip it out if it exists.
        tmp = ua.split('Twitter');
        if (typeof tmp[1] !== 'undefined') {
            ua = tmp[0];
        }

        this.apple = {
            phone:  match(apple_phone, ua),
            ipod:   match(apple_ipod, ua),
            tablet: !match(apple_phone, ua) && match(apple_tablet, ua),
            device: match(apple_phone, ua) || match(apple_ipod, ua) || match(apple_tablet, ua)
        };
        this.amazon = {
            phone:  match(amazon_phone, ua),
            tablet: !match(amazon_phone, ua) && match(amazon_tablet, ua),
            device: match(amazon_phone, ua) || match(amazon_tablet, ua)
        };
        this.android = {
            phone:  match(amazon_phone, ua) || match(android_phone, ua),
            tablet: !match(amazon_phone, ua) && !match(android_phone, ua) && (match(amazon_tablet, ua) || match(android_tablet, ua)),
            device: match(amazon_phone, ua) || match(amazon_tablet, ua) || match(android_phone, ua) || match(android_tablet, ua)
        };
        this.windows = {
            phone:  match(windows_phone, ua),
            tablet: match(windows_tablet, ua),
            device: match(windows_phone, ua) || match(windows_tablet, ua)
        };
        this.other = {
            blackberry:   match(other_blackberry, ua),
            blackberry10: match(other_blackberry_10, ua),
            opera:        match(other_opera, ua),
            firefox:      match(other_firefox, ua),
            chrome:       match(other_chrome, ua),
            device:       match(other_blackberry, ua) || match(other_blackberry_10, ua) || match(other_opera, ua) || match(other_firefox, ua) || match(other_chrome, ua)
        };
        this.seven_inch = match(seven_inch, ua);
        this.any = this.apple.device || this.android.device || this.windows.device || this.other.device || this.seven_inch;

        // excludes 'other' devices and ipods, targeting touchscreen phones
        this.phone = this.apple.phone || this.android.phone || this.windows.phone;

        // excludes 7 inch devices, classifying as phone or tablet is left to the user
        this.tablet = this.apple.tablet || this.android.tablet || this.windows.tablet;

        if (typeof window === 'undefined') {
            return this;
        }
    };

    var instantiate = function() {
        var IM = new IsMobileClass();
        IM.Class = IsMobileClass;
        return IM;
    };

    if (typeof module !== 'undefined' && module.exports && typeof window === 'undefined') {
        //node
        module.exports = IsMobileClass;
    } else if (typeof module !== 'undefined' && module.exports && typeof window !== 'undefined') {
        //browserify
        module.exports = instantiate();
    } else if (typeof define === 'function' && define.amd) {
        //AMD
        define('isMobile', [], global.isMobile = instantiate());
    } else {
        global.isMobile = instantiate();
    }

})(this);

},{}],3:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 *  Actor
 *
 *  Created by Legman on 22/02/2017.
 *
 */

/**
 * @class
 */
var Actor = function (_PIXI$Container) {
    _inherits(Actor, _PIXI$Container);

    /**
     * @param {PIXI.Texture} [texture]
     * @constructor
     */
    function Actor(texture) {
        _classCallCheck(this, Actor);

        var _this = _possibleConstructorReturn(this, (Actor.__proto__ || Object.getPrototypeOf(Actor)).call(this));

        texture = texture || PIXI.Texture.EMPTY;

        /**
         * @member {PIXI.Sprite | PIXI.spine.Spine}
         */
        if (texture) {
            _this.view = new PIXI.Sprite(texture);
            _this.view.anchor = new PIXI.Point(0.5, 0.5);
            _this.addChild(_this.view);
        }

        /**
         * @member {boolean}
         */
        _this.destroyNextFrame = false;

        _this.on("added", _this.init, _this);
        return _this;
    }

    _createClass(Actor, [{
        key: "init",
        value: function init() {
            this.off("added", this.init);
        }

        /**
         * @param {boolean} [destroyChildren]
         */

    }, {
        key: "destroy",
        value: function destroy(destroyChildren) {}
    }, {
        key: "update",
        value: function update() {}

        /**
         * @returns {PIXI.Container}
         */

    }, {
        key: "spine",
        get: function get() {
            return this.view;
        }

        /**
         * @param {PIXI.Container} value
         */
        ,
        set: function set(value) {
            this.view = value;
        }
    }]);

    return Actor;
}(PIXI.Container);

exports.default = Actor;

},{}],4:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }(); /**
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      *  AnimationScene
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      *
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      *  Created by Legman on 4/09/2015.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      *
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      */

var _Common = require("./Common");

var _Common2 = _interopRequireDefault(_Common);

var _GameScene = require("./GameScene");

var _GameScene2 = _interopRequireDefault(_GameScene);

var _EndScene = require("./EndScene");

var _EndScene2 = _interopRequireDefault(_EndScene);

var _HelpScene = require("./HelpScene");

var _HelpScene2 = _interopRequireDefault(_HelpScene);

var _IntroScene = require("./IntroScene");

var _IntroScene2 = _interopRequireDefault(_IntroScene);

var _PauseScene = require("./PauseScene");

var _PauseScene2 = _interopRequireDefault(_PauseScene);

var _SplashScene = require("./SplashScene");

var _SplashScene2 = _interopRequireDefault(_SplashScene);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * @class
 */
var Application = function () {
    function Application() {
        _classCallCheck(this, Application);
    }

    _createClass(Application, [{
        key: "init",
        value: function init() {
            this.showSplashScene();
        }

        /**
         * @param {p3.Transition} [transition]
         * @returns {p3.Scene}
         */

    }, {
        key: "showSplashScene",
        value: function showSplashScene(transition) {
            var scene = new _SplashScene2.default();
            scene.signals.next.add(function () {
                this.showIntroScene();
            }, this);

            transition = transition || new p3.FadeTransition();
            _Common2.default.scene.add(scene, transition);

            _Common2.default.audio.playMusic("music_mainmenu_screen_00");

            return scene;
        }

        /**
         * @param {p3.Transition} [transition]
         * @returns {p3.Scene}
         */

    }, {
        key: "showIntroScene",
        value: function showIntroScene(transition) {
            var scene = new _IntroScene2.default();
            scene.signals.next.add(function () {
                this.showGameScene();
            }, this);

            transition = transition || new p3.FadeTransition();
            _Common2.default.scene.add(scene, transition);

            _Common2.default.audio.playMusic("music_pause_screen_00");

            return scene;
        }

        /**
         * @param {p3.Transition} [transition]
         * @returns {p3.Scene}
         */

    }, {
        key: "showGameScene",
        value: function showGameScene(transition) {
            _Common2.default.paused = false;

            var scene = new _GameScene2.default();
            scene.signals.next.add(function (scene, score) {
                _Common2.default.saveHighscore(score);
                this.showEndScene(score);
            }, this);
            scene.signals.pause.add(function () {
                scene.pauseGame();

                this.showPauseScene();
            }, this);

            transition = transition || new p3.FadeTransition();
            _Common2.default.scene.add(scene, transition);

            _Common2.default.audio.playMusic("music_ingame_00");

            return scene;
        }

        /**
         * @param {p3.Transition} [transition]
         * @returns {p3.Scene}
         */

    }, {
        key: "showPauseScene",
        value: function showPauseScene(transition) {
            _Common2.default.paused = true;

            var scene = new _PauseScene2.default();
            scene.signals.next.add(function () {
                _Common2.default.paused = false;

                _Common2.default.scene.remove();

                _Common2.default.audio.playMusic("music_ingame_00");
            }, this);
            scene.signals.home.add(function () {
                _Common2.default.paused = false;

                this.showSplashScene();
            }, this);

            if (!transition) {
                transition = new p3.Transition();
                transition.push = true;
                transition.replace = false;
            }
            _Common2.default.scene.add(scene, transition);

            _Common2.default.audio.playMusic("music_pause_screen_00");

            return scene;
        }

        /**
         * @param {p3.Transition} [transition]
         * @returns {p3.Scene}
         */

    }, {
        key: "showHelpScene",
        value: function showHelpScene(transition) {
            var scene = new _HelpScene2.default();
            scene.signals.next.add(function () {
                var transition = new p3.Transition();
                transition.swap = true;
                this.showPauseScene(transition);
            }, this);

            if (!transition) {
                transition = new p3.Transition();
                transition.swap = true;
            }
            _Common2.default.scene.add(scene, transition);
            return scene;
        }

        /**
         * @param {!number} [score]
         * @param {p3.Transition} [transition]
         * @returns {p3.Scene}
         */

    }, {
        key: "showEndScene",
        value: function showEndScene(score, transition) {
            var scene = new _EndScene2.default(score);
            scene.signals.next.add(function () {
                this.showGameScene();
            }, this);
            scene.signals.home.add(function () {
                this.showSplashScene();
            }, this);

            transition = transition || new p3.FadeTransition();
            _Common2.default.scene.add(scene, transition);

            _Common2.default.audio.playMusic("music_score_screen_00");

            return scene;
        }
    }]);

    return Application;
}();

exports.default = Application;

},{"./Common":11,"./EndScene":12,"./GameScene":13,"./HelpScene":15,"./IntroScene":18,"./PauseScene":21,"./SplashScene":25}],5:[function(require,module,exports){
"use strict";

/**
 *  Audio
 *
 *  Created by Legman on 12/09/2016.
 *
 */

/**
 * @constructor
 */
function Audio() {
  /**
   * @type {number}
   */
  this.id = -1;

  /**
   * @type {Howl}
   */
  this.howl = null;
}
module.exports = Audio;

Audio.prototype.stop = function () {
  this.howl.stop(this.id);
};

},{}],6:[function(require,module,exports){
"use strict";

/**
 *  AudioManager
 *
 *  Created by Legman on 25/02/2016.
 *
 */

var Audio = require("./Audio");
var AudioParams = require("./AudioParams");

function AudioManager() {
    /**
     * @type {object}
     * @private
     */
    this._cache = {};

    /**
     * @type {Howl}
     * @private
     */
    this._music = null;

    /**
     * @type {boolean}
     * @private
     */
    this._isMuted = false;

    var hidden;
    "undefined" != typeof document.hidden ? (hidden = "hidden", this.visibilityChange = "visibilitychange") : "undefined" != typeof document.mozHidden ? (hidden = "mozHidden", this.visibilityChange = "mozvisibilitychange") : "undefined" != typeof document.msHidden ? (hidden = "msHidden", this.visibilityChange = "msvisibilitychange") : "undefined" != typeof document.webkitHidden && (hidden = "webkitHidden", this.visibilityChange = "webkitvisibilitychange");

    document.addEventListener(this.visibilityChange, function () {
        document[hidden] ? Howler.volume(0) : Howler.volume(1);
    }, false);
}
module.exports = AudioManager;

/**
 * @param {!Array.<string>} sounds
 * @param {!Array.<string>} extensions
 * @param {string=} basePath
 */
AudioManager.prototype.addSounds = function (sounds, extensions, basePath) {
    basePath = basePath || "";

    var howl, name, url, urls, extension, i, j;
    for (i = 0; i < sounds.length; ++i) {
        url = basePath + sounds[i];
        url = url.split("/");
        name = url[url.length - 1];

        urls = [];
        for (j = 0; j < extensions.length; ++j) {
            extension = extensions[j];
            urls.push(url.join("/") + extension);
        }
        howl = new Howl({
            src: urls,
            volume: 1.0,
            loop: false,
            autoplay: false
        });
        howl.name = name;
        this._cache[name] = howl;
    }
};

/**
 * @param {!Array.<string>} name
 * @param {!Array.<string>} sprite
 * @param {!Array.<string>} extensions
 * @param {string=} basePath
 */
AudioManager.prototype.addSoundSprite = function (name, sprite, extensions, basePath) {
    basePath = basePath || "";

    var extension;

    var url = basePath + name;
    url = url.split("/");

    var urls = [];
    for (var i = 0; i < extensions.length; ++i) {
        extension = extensions[i];
        urls.push(url.join("/") + extension);
    }

    var howl = new Howl({
        src: urls,
        sprite: sprite,
        volume: 1,
        loop: false,
        autoplay: false
    });
    for (var key in sprite) {
        if (sprite.hasOwnProperty(key)) {
            this._cache[key] = howl;
        }
    }
};

/**
 * @param {!Array.<string>} sounds
 */
AudioManager.prototype.removeSounds = function (sounds) {
    var name, n, howl;
    for (var i = 0; i < sounds.length; ++i) {
        name = sounds[i];
        for (n in this._cache) {
            if (this._cache.hasOwnProperty(key)) {
                howl = this._cache[key];
                if (howl.name == n) {
                    howl.unload();
                    delete this._cache[name];
                    break;
                }
            }
        }
    }
};

/**
 * @param {!string | Array.<string>} name
 * @param {AudioParams=} params
 * @returns {Audio}
 */
AudioManager.prototype.playSound = function (name, params) {
    params = params || new AudioParams();

    var id = -1;

    if (typeof name !== "string") {
        name = name[Math.floor(Math.random() * name.length)];
    }

    var howl = this._cache[name];
    if (!howl) {
        console.warn("Could not find sound - " + name);
        return id;
    }

    id = howl.play(howl._sprite ? name : 0);
    howl.volume(params.volume, id);
    howl.loop(params.loop, id);

    var audio = new Audio();
    audio.id = id;
    audio.howl = howl;
    return audio;
};

/**
 * @param {!string | Array.<string>} name
 * @param {AudioParams=} params
 * @returns {Audio}
 */
AudioManager.prototype.playMusic = function (name, params) {
    params = params || new AudioParams();

    var id = -1;

    if (typeof name !== "string") {
        name = name[Math.floor(Math.random() * name.length)];
    }

    // skip if no change
    if (this._music && this._music.howl.name == name) {
        return this._music;
    }

    var howl = this._cache[name];
    if (!howl) {
        console.warn("Could not find music - " + name);
        return null;
    }

    // callback
    howl.__onend = function () {
        params.callback && params.callback.call(params.scope);
    };
    howl.on("end", howl.__onend);

    if (p3.Device && p3.Device.isAndroidStockBrowser) {
        howl.buffer = true;
    }

    id = howl.play();
    howl.volume(params.volume, id);
    howl.loop(true, id);

    var audio = new Audio();
    audio.id = id;
    audio.howl = howl;

    if (params.fadeIn > 0.0) {
        if (this._music) {
            this.fadeOut(this._music, params.fadeIn);
        }
        this.fadeIn(audio, params.fadeIn);
    } else {
        this._music && this.stopMusic();
    }

    this._music = audio;
    return audio;
};

/**
 * @param {!string} name
 * @param {number=} id
 * @deprecated
 */
AudioManager.prototype.stopSound = function (name, id) {
    var howl = this._cache[name];
    !howl && console.warn("Could not find sound - " + name);
    howl.stop(id);

    console.warn("'AudioManager.stopSound()' is deprecated. Use 'Audio.stop()' instead.");
};

AudioManager.prototype.stopMusic = function () {
    if (this._music) {
        this._music.howl.__onend && this._music.howl.off("end", this._music.howl.__onend);
        this._music.stop();
        this._music = null;
    }
};

/**
 * @param {!boolean} value
 */
AudioManager.prototype.mute = function (value) {
    this._isMuted = value;
    if (this._isMuted) {
        Howler.mute(true);
    } else {
        Howler.mute(false);
    }
};

/**
 * @param {!Audio} audio
 * @param {number=} duration
 * @param {function=} callback
 * @param {*=} scope
 */
AudioManager.prototype.fadeIn = function (audio, duration, callback, scope) {
    duration = duration || 1.0;

    var volume = audio.howl.volume(audio.id);
    audio.howl.volume(0.0, audio.id);
    audio.__volume = 0.0;

    TweenMax.killTweensOf(audio);
    TweenMax.to(audio, duration, {
        __volume: volume,
        ease: Power1.easeInOut,
        onUpdate: function onUpdate() {
            audio.howl.volume(audio.__volume, audio.id);
        },
        onUpdateScope: this,
        onComplete: callback,
        onCompleteParams: [audio],
        onCompleteScope: scope
    });
};

/**
 * @param {!Audio} audio
 * @param {number=} duration
 * @param {function=} callback
 * @param {*=} scope
 */
AudioManager.prototype.fadeOut = function (audio, duration, callback, scope) {
    duration = duration || 1.0;

    audio.__volume = audio.howl.volume(audio.id);

    TweenMax.killTweensOf(audio);
    TweenMax.to(audio, duration, {
        __volume: 0.0,
        ease: Power1.easeInOut,
        onUpdate: function onUpdate() {
            audio.howl.volume(audio.__volume, audio.id);
            console.log(audio.__volume);
        },
        onUpdateScope: this,
        onComplete: callback,
        onCompleteParams: [audio],
        onCompleteScope: scope
    });
};

/**
 * @param {!Audio} audio
 * @param {!*} object
 * @param {!Camera} camera
 * @param {number=} min
 * @param {number=} max
 */
AudioManager.prototype.setAudioPos3D = function (audio, object, camera, min, max) {
    if (p3.Device.isMobile || !p3.Device.bowser["chrome"]) return;

    min = min || 0.0;
    max = max || 320.0;

    var layer = camera.findLayerForObject(object);
    var x = object.x * (1.0 / layer.parallax.x);
    var sign = x - camera.position.x;
    sign = sign / Math.abs(sign);

    if (sign == -1) x = Math.min(0.0, (x + min - camera.position.x) / (max - min));else if (sign == 1) x = Math.max(0.0, (x - min - camera.position.x) / (max - min));

    audio.howl.pos(x, 0.0, 0.0, audio.id);
};

/**
 * @param {Audio} audio
 * @param {*} object
 * @param {Camera} camera
 * @param {!number} [min]
 * @param {!number} [max]
 * @param {!number} [offset]
 * @param {boolean} [fallback]
 */
AudioManager.prototype.setAudioPosStereo = function (audio, object, camera, min, max, offset, fallback) {
    if (p3.Device.isMobile || !p3.Device.bowser["chrome"]) {
        fallback = true;
    }

    min = min || 0.0;
    max = max || 320.0;
    offset = offset || 0;

    var layer = camera.findLayerForObject(object);
    var x = (object.x + offset) * (1.0 / layer.parallax.x);
    var sign = x - camera.position.x;
    sign = sign / Math.abs(sign);

    x = Math.max(0.0, Math.abs(x - min - camera.position.x) / max);
    x = Math.max(0.0, Math.min(1.0, 1.0 + (1.0 - x)));

    audio.howl.volume(x, audio.id);

    if (fallback) return;

    x = (object.x + offset) * (1.0 / layer.parallax.x);

    if (sign == -1) x = Math.min(0.0, (x + min - camera.position.x) / (max - min));else if (sign == 1) x = Math.max(0.0, (x - min - camera.position.x) / (max - min));

    x = Math.max(-1.0, Math.min(1.0, x));
    audio.howl.stereo(x, audio.id);
};

Object.defineProperty(AudioManager.prototype, "isMute", {
    /**
     * @returns {!boolean}
     */
    get: function get() {
        return this._isMuted;
    }
});

},{"./Audio":5,"./AudioParams":7}],7:[function(require,module,exports){
"use strict";

/**
 *  AudioParams
 *
 *  Created by Legman on 25/02/2016.
 *
 */

/**
 * @constructor
 */
function AudioParams() {
  /**
   * @type {number}
   */
  this.volume = 1.0;

  /**
   * @type {boolean}
   */
  this.loop = false;

  /**
   * @type {number}
   */
  this.delay = 0.0;

  /**
   * @type {number}
   */
  this.fadeIn = 0.0;

  /**
   * @type {number}
   */
  this.priority = 0;

  /**
   * @type {function}
   */
  this.callback = null;

  /**
   * @type {*}
   */
  this.scope = window;
}
module.exports = AudioParams;

},{}],8:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _Actor2 = require("./Actor");

var _Actor3 = _interopRequireDefault(_Actor2);

var _Common = require("./Common");

var _Common2 = _interopRequireDefault(_Common);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /**
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *  BaseTile
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *  Created by Legman on 13/03/2017.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */

/**
 * @class
 */
var BaseTile = function (_Actor) {
    _inherits(BaseTile, _Actor);

    /**
     * @param {PIXI.Texture} [texture]
     */
    function BaseTile(texture) {
        _classCallCheck(this, BaseTile);

        /**
         * @member {Array.<PIXI.Sprite>}
         * @private
         */
        var _this = _possibleConstructorReturn(this, (BaseTile.__proto__ || Object.getPrototypeOf(BaseTile)).call(this, texture));

        _this._lights = [];
        return _this;
    }

    /**
     * @param {boolean} [destroyChildren]
     */


    _createClass(BaseTile, [{
        key: "destroy",
        value: function destroy(destroyChildren) {
            for (var i = 0; i < this._lights; ++i) {
                var light = this._lights[i];
                TweenMax.killTweensOf(light);
            }
            this._lights.length = 0;

            _get(BaseTile.prototype.__proto__ || Object.getPrototypeOf(BaseTile.prototype), "destroy", this).call(this, destroyChildren);
        }

        /**
         * @returns {PIXI.Sprite}
         */

    }, {
        key: "createLight",
        value: function createLight() {
            var assets = _Common2.default.assets;
            var textures = ["side_light_001", "side_light_002", "side_light_003"];

            var light = new PIXI.Sprite(assets.getTexture(textures[Math.floor(Math.random() * textures.length)]));
            light.alpha = 0.2 + Math.random() * 0.2;
            light.blendMode = PIXI.BLEND_MODES.ADD;
            light.anchor.y = 0.5;
            this.addChild(light);
            this._lights.push(light);

            var duration = 1 + Math.random() * 2;
            var delay = Math.random();

            TweenMax.to(light, duration, {
                delay: delay,
                alpha: 0.14,
                ease: Power1.easeInOut,
                yoyo: true,
                repeat: -1
            });

            return light;
        }
    }]);

    return BaseTile;
}(_Actor3.default);

exports.default = BaseTile;

},{"./Actor":3,"./Common":11}],9:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _Common = require("./Common");

var _Common2 = _interopRequireDefault(_Common);

var _ismobilejs = require("ismobilejs");

var _ismobilejs2 = _interopRequireDefault(_ismobilejs);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /**
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *  BoomerangPreloaderScene
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *  Created by Legman on 7/10/2015.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */

/**
 * @class
 */
var BoomerangPreloaderScene = function (_p3$Scene) {
    _inherits(BoomerangPreloaderScene, _p3$Scene);

    function BoomerangPreloaderScene() {
        _classCallCheck(this, BoomerangPreloaderScene);

        /**
         * @member {number}
         */
        var _this = _possibleConstructorReturn(this, (BoomerangPreloaderScene.__proto__ || Object.getPrototypeOf(BoomerangPreloaderScene)).call(this));

        _this.loaded = 0;

        /**
         * @member {PIXI.Sprite}
         * @private
         */
        _this._bar = null;

        /**
         * @member {PIXI.BitmapText}
         * @private
         */
        _this._text = null;

        /**
         * @member {PIXI.extras.MovieClip}
         * @private
         */
        _this._logo = null;

        /**
         * @member {p3.Button}
         * @private
         */
        _this._playButton = null;

        /**
         * @member {boolean}
         * @private
         */
        _this._finishedLoading = false;
        return _this;
    }

    _createClass(BoomerangPreloaderScene, [{
        key: "init",
        value: function init() {
            _get(BoomerangPreloaderScene.prototype.__proto__ || Object.getPrototypeOf(BoomerangPreloaderScene.prototype), "init", this).call(this);

            var assets = _Common2.default.assets;

            var g = new PIXI.Graphics();
            g.clear();
            g.beginFill(0x872F87);
            g.drawRect(0, 0, _Common2.default.STAGE_WIDTH, _Common2.default.STAGE_HEIGHT);
            g.endFill();
            this.addChild(g);

            var holder = new PIXI.Container();
            holder.x = _Common2.default.STAGE_WIDTH * 0.5;
            holder.y = _Common2.default.STAGE_HEIGHT * 0.5 + 46;
            this.addChild(holder);

            var frames = [];
            for (var i = 1; i < 10; ++i) {
                frames.push(assets.getTexture("loader_animation000" + i));
            }
            frames.push(assets.getTexture("loader_animation0010"));

            var sequence = new p3.MovieClipSequence();
            sequence.addTextures(frames);

            this._logo = new p3.MovieClip(sequence);
            this._logo.x = 50;
            this._logo.y = 20;
            this._logo.anchor = new PIXI.Point(0.5, 1);
            this._logo.animationSpeed = 1 / 4;
            this._logo.looping = false;
            holder.addChild(this._logo);

            this._bar = new PIXI.Sprite(assets.getTexture("preloader_bg"));
            this._bar.y = 34;
            this._bar.anchor = new PIXI.Point(0.5, 0.5);
            holder.addChild(this._bar);

            this._bar.fill = new PIXI.Sprite(assets.getTexture("preloader_bar"));
            this._bar.fill.anchor = new PIXI.Point(0.5, 0.5);
            this._bar.addChild(this._bar.fill);

            this._bar.fill.mask = new PIXI.Graphics();
            this._bar.fill.mask.x = -this._bar.fill.texture.width * 0.5;
            this._bar.fill.mask.scale.x = 0;
            this._bar.fill.mask.beginFill(0xFF0000);
            this._bar.fill.mask.drawRect(0, -this._bar.fill.texture.height * 0.5, this._bar.fill.texture.width, this._bar.fill.texture.height);
            this._bar.fill.addChild(this._bar.fill.mask);

            this._bar.frame = new PIXI.Sprite(assets.getTexture("preloader_overlay"));
            this._bar.frame.anchor = new PIXI.Point(0.5, 0.5);
            this._bar.addChild(this._bar.frame);

            this._text = new PIXI.Text("0%", { fontSize: "32px", fontFamily: "Arial", fill: "#FFFFFF", align: "center" });
            this._text.y = this._bar.y + 60;
            this._text.pivot.x = this._text.width * 0.5;
            this._text.pivot.y = this._text.height * 0.5;
            holder.addChild(this._text);

            var states = new p3.ButtonStates();
            states.normal = assets.getTexture("btn_large_off");
            states.icon = assets.getTexture("icon_large_play_off");

            this._playButton = new p3.Button(states);
            this._playButton.x = p3.View.width * 0.5;
            this._playButton.y = _Common2.default.STAGE_HEIGHT * 0.5 + 280;
            this._playButton.overSoundName = "sfx_btn_press_00";
            this._playButton.downSoundName = "sfx_btn_home_00";
            this._playButton.visible = false;
            this._playButton.signals.click.add(this.onPlayButtonClick, this);
            this.addChild(this._playButton);

            Howler.ctx.resume();
        }
    }, {
        key: "appear",
        value: function appear() {
            _get(BoomerangPreloaderScene.prototype.__proto__ || Object.getPrototypeOf(BoomerangPreloaderScene.prototype), "appear", this).call(this);

            this._logo.play();
        }
    }, {
        key: "resize",
        value: function resize() {
            this.y = (p3.View.height - _Common2.default.STAGE_HEIGHT) * 0.5;
        }
    }, {
        key: "update",
        value: function update() {
            var loaded = Math.min(1, this.loaded);
            this._bar.fill.mask.scale.x += (loaded - this._bar.fill.mask.scale.x) * 0.4;

            this._text.text = "" + Math.round(loaded * 100) + "%";
            this._text.pivot.x = this._text.width * 0.5;

            if (_ismobilejs2.default.any) {
                if (loaded >= 1 && !this._finishedLoading) {
                    this._finishedLoading = true;

                    this._playButton.scale = new PIXI.Point();
                    TweenMax.to(this._playButton.scale, 0.34, {
                        x: 1.0,
                        y: 1.0,
                        ease: Back.easeOut,
                        easeParams: [2],
                        onStart: function onStart() {
                            this._playButton.visible = true;
                        },
                        onStartScope: this
                    });
                }
            }
        }
    }, {
        key: "onPlayButtonClick",
        value: function onPlayButtonClick(button) {
            this.signals.next.dispatch(this);

            Howler.ctx.resume();

            _Common2.default.audio.playMusic("music_mainmenu_screen_00");
        }
    }]);

    return BoomerangPreloaderScene;
}(p3.Scene);

exports.default = BoomerangPreloaderScene;

},{"./Common":11,"ismobilejs":2}],10:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _Common = require("./Common");

var _Common2 = _interopRequireDefault(_Common);

var _ismobilejs = require("ismobilejs");

var _ismobilejs2 = _interopRequireDefault(_ismobilejs);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /**
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *  CNPreloaderScene
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *  Created by Legman on 7/10/2015.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */

/**
 * @class
 */
var CNPreloaderScene = function (_p3$Scene) {
    _inherits(CNPreloaderScene, _p3$Scene);

    function CNPreloaderScene() {
        _classCallCheck(this, CNPreloaderScene);

        /**
         * @member {number}
         */
        var _this = _possibleConstructorReturn(this, (CNPreloaderScene.__proto__ || Object.getPrototypeOf(CNPreloaderScene)).call(this));

        _this.loaded = 0;

        /**
         * @member {PIXI.Sprite}
         * @private
         */
        _this._bar = null;

        /**
         * @member {PIXI.BitmapText}
         * @private
         */
        _this._text = null;

        /**
         * @member {PIXI.extras.MovieClip}
         * @private
         */
        _this._logo = null;

        /**
         * @member {p3.Button}
         * @private
         */
        _this._playButton = null;

        /**
         * @member {boolean}
         * @private
         */
        _this._finishedLoading = false;
        return _this;
    }

    _createClass(CNPreloaderScene, [{
        key: "init",
        value: function init() {
            _get(CNPreloaderScene.prototype.__proto__ || Object.getPrototypeOf(CNPreloaderScene.prototype), "init", this).call(this);

            var assets = _Common2.default.assets;

            var g = new PIXI.Graphics();
            g.clear();
            g.beginFill(0x0);
            g.drawRect(0, 0, _Common2.default.STAGE_WIDTH, _Common2.default.STAGE_HEIGHT);
            g.endFill();
            this.addChild(g);

            var bg = new PIXI.Sprite(assets.getTexture("cn_preloader"));
            bg.x = _Common2.default.STAGE_WIDTH * 0.5 - 10;
            bg.y = _Common2.default.STAGE_HEIGHT * 0.5 + 4;
            bg.anchor = new PIXI.Point(0.5, 0.5);
            this.addChild(bg);

            var holder = new PIXI.Container();
            holder.x = _Common2.default.STAGE_WIDTH * 0.5;
            holder.y = _Common2.default.STAGE_HEIGHT * 0.5 + 46;
            this.addChild(holder);

            this._bar = new PIXI.Container();
            this._bar.y = 90;
            this._bar.scale = new PIXI.Point(0.9, 0.9);
            this._bar.anchor = new PIXI.Point(0.5, 0.5);
            holder.addChild(this._bar);

            this._bar.fill = new PIXI.Sprite(assets.getTexture("preloader_fill"));
            this._bar.fill.anchor = new PIXI.Point(0.5, 0.5);
            this._bar.addChild(this._bar.fill);

            this._bar.fill.mask = new PIXI.Graphics();
            this._bar.fill.mask.x = -this._bar.fill.texture.width * 0.5;
            this._bar.fill.mask.scale.x = 0;
            this._bar.fill.mask.beginFill(0xFF0000);
            this._bar.fill.mask.drawRect(0, -this._bar.fill.texture.height * 0.5, this._bar.fill.texture.width, this._bar.fill.texture.height);
            this._bar.fill.addChild(this._bar.fill.mask);

            this._bar.frame = new PIXI.Sprite(assets.getTexture("preloader_overlay"));
            this._bar.frame.x = -260;
            this._bar.frame.anchor = new PIXI.Point(0.5, 0.5);
            this._bar.addChild(this._bar.frame);

            var states = new p3.ButtonStates();
            states.normal = assets.getTexture("btn_large_off");
            states.icon = assets.getTexture("icon_large_play_off");

            this._playButton = new p3.Button(states);
            this._playButton.x = p3.View.width * 0.5;
            this._playButton.y = _Common2.default.STAGE_HEIGHT * 0.5 + 300;
            this._playButton.overSoundName = "sfx_btn_press_00";
            this._playButton.downSoundName = "sfx_btn_home_00";
            this._playButton.visible = false;
            this._playButton.signals.click.add(this.onPlayButtonClick, this);
            this.addChild(this._playButton);

            Howler.ctx.resume();
        }
    }, {
        key: "appear",
        value: function appear() {
            _get(CNPreloaderScene.prototype.__proto__ || Object.getPrototypeOf(CNPreloaderScene.prototype), "appear", this).call(this);
        }
    }, {
        key: "resize",
        value: function resize() {
            this.y = (p3.View.height - _Common2.default.STAGE_HEIGHT) * 0.5;
        }
    }, {
        key: "update",
        value: function update() {
            var loaded = Math.min(1, this.loaded);
            this._bar.fill.mask.scale.x += (loaded - this._bar.fill.mask.scale.x) * 0.4;

            if (_ismobilejs2.default.any) {
                if (loaded >= 1 && !this._finishedLoading) {
                    this._finishedLoading = true;

                    this._playButton.scale = new PIXI.Point();
                    TweenMax.to(this._playButton.scale, 0.34, {
                        x: 1.0,
                        y: 1.0,
                        ease: Back.easeOut,
                        easeParams: [2],
                        onStart: function onStart() {
                            this._playButton.visible = true;
                        },
                        onStartScope: this
                    });
                }
            }
        }
    }, {
        key: "onPlayButtonClick",
        value: function onPlayButtonClick(button) {
            Howler.ctx.resume();

            this.signals.next.dispatch(this);

            _Common2.default.audio.playMusic("music_mainmenu_screen_00");
        }
    }]);

    return CNPreloaderScene;
}(p3.Scene);

exports.default = CNPreloaderScene;

},{"./Common":11,"ismobilejs":2}],11:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 *  Common
 *
 *  Created by Legman on 4/09/2015.
 *
 */

/**
 * @class
 */
var Common = function () {
  function Common() {
    _classCallCheck(this, Common);
  }

  _createClass(Common, null, [{
    key: "getHighscore",

    /**
     * @returns {number}
     */
    value: function getHighscore() {
      var score = window.localStorage["cn_towerofsteve"];
      return score || 0;
    }

    /**
     * @param {!number} score
     */

  }, {
    key: "saveHighscore",
    value: function saveHighscore(score) {
      if (score > Common.getHighscore()) {
        window.localStorage["cn_towerofsteve"] = score;
      }
    }
  }]);

  return Common;
}();

/**
 * @static
 * @type {number}
 * @const
 */


exports.default = Common;
Common.STAGE_WIDTH = 768;

/**
 * @static
 * @type {number}
 * @const
 */
Common.STAGE_HEIGHT = 1900.0;

/**
 * @static
 * @type {number}
 * @const
 */
Common.PHYSICS_TICK = 1.0 / 30.0;

/**
 * @static
 * @type {PIXI.Container}
 */
Common.stage = null;

/**
 * @static
 * @type {PIXI.CanvasRenderer|PIXI.WebGLRenderer}
 */
Common.renderer = null;

/**
 * @static
 * @type {p3.Timestep}
 */
Common.timestep = null;

/**
 * @static
 * @type {p3.Tracking}
 */
Common.tracking = null;

/**
 * @static
 * @type {AudioManager}
 */
Common.audio = null;

/**
 * @static
 * @type {p3.Camera}
 */
Common.camera = null;

/**
 * @static
 * @type {object}
 */
Common.copy = null;

/**
 * @static
 * @type {object}
 */
Common.config = null;

/**
 * @static
 * @type {string}
 */
Common.language = "en";

/**
 * @static
 * @type {PIXI.Point}
 */
Common.touch = new PIXI.Point(0, 0);

/**
 * @static
 * @type {boolean}
 */
Common.touching = false;

/**
 * @static
 * @type {boolean}
 */
Common.paused = false;

/**
 * @static
 * @type {boolean}
 */
Common.isWebGL = false;

/**
 * @static
 * @type {boolean}
 */
Common.isFirstTime = true;

},{}],12:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _Common = require("./Common");

var _Common2 = _interopRequireDefault(_Common);

var _ScanlinesFilter = require("./ScanlinesFilter");

var _ScanlinesFilter2 = _interopRequireDefault(_ScanlinesFilter);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /**
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *  EndScene
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *  Created by Legman on 24/02/2017.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */

/**
 * @class
 */
var EndScene = function (_p3$Scene) {
    _inherits(EndScene, _p3$Scene);

    /**
     * @param {!number} [score]
     * @constructor
     */
    function EndScene(score) {
        _classCallCheck(this, EndScene);

        /**
         * @member {number}
         * @private
         */
        var _this = _possibleConstructorReturn(this, (EndScene.__proto__ || Object.getPrototypeOf(EndScene)).call(this));

        _this._score = score || 0;

        /**
         * @member {PIXI.Sprite}
         * @private
         */
        _this._tvs = null;

        /**
         * @member {PIXI.Sprite}
         * @private
         */
        _this._flint = null;

        /**
         * @member {PIXI.Sprite}
         * @private
         */
        _this._steve = null;

        /**
         * @member {PIXI.extras.BitmapText | PIXI.Text}
         * @private
         */
        _this._gameLabel = null;

        /**
         * @member {PIXI.extras.BitmapText | PIXI.Text}
         * @private
         */
        _this._overLabel = null;

        /**
         * @member {PIXI.extras.BitmapText | PIXI.Text}
         * @private
         */
        _this._scoreLabel = null;

        /**
         * @member {PIXI.extras.BitmapText | PIXI.Text}
         * @private
         */
        _this._scoreValueLabel = null;

        /**
         * @member {PIXI.extras.BitmapText | PIXI.Text}
         * @private
         */
        _this._bestLabel = null;

        /**
         * @member {PIXI.extras.BitmapText | PIXI.Text}
         * @private
         */
        _this._bestValueLabel = null;

        /**
         * @member {p3.Button}
         * @private
         */
        _this._replayButton = null;

        /**
         * @member {p3.Button}
         * @private
         */
        _this._nextButton = null;

        /**
         * @member {PIXI.particles.Emitter}
         * @private
         */
        _this._emitter = null;
        return _this;
    }

    _createClass(EndScene, [{
        key: "init",
        value: function init() {
            _get(EndScene.prototype.__proto__ || Object.getPrototypeOf(EndScene.prototype), "init", this).call(this);

            var assets = _Common2.default.assets;

            var bg = new PIXI.Sprite(assets.getTexture("bg_end"));
            this.addChild(bg);

            var holder = new PIXI.Container();
            this.addChild(holder);

            var config = assets.getJSON("end_game_confetti");
            this._emitter = new PIXI.particles.Emitter(holder, [assets.getTexture("particle_end_001"), assets.getTexture("particle_end_002"), assets.getTexture("particle_end_003"), assets.getTexture("particle_end_004"), assets.getTexture("particle_end_005"), assets.getTexture("particle_end_006"), assets.getTexture("particle_end_007"), assets.getTexture("particle_end_008"), assets.getTexture("particle_end_009"), assets.getTexture("particle_end_010"), assets.getTexture("particle_end_011"), assets.getTexture("particle_end_012")], config);
            this._emitter.emit = true;
            var i = Math.floor(Math.random() * 1000);
            while (--i > 0) {
                this._emitter.update(deltaTime);
            }

            this._tvs = new PIXI.Sprite(assets.getTexture("end_mg"));
            this._tvs.x = p3.View.width * 0.5;
            this._tvs.y = _Common2.default.STAGE_HEIGHT * 0.5 - 44;
            this._tvs.anchor = new PIXI.Point(0.5, 0.5);
            this.addChild(this._tvs);

            this._tvs.screens = new PIXI.Sprite(assets.getTexture("end_mg_screens"));
            this._tvs.screens.anchor = new PIXI.Point(0.5, 0.5);
            this._tvs.addChild(this._tvs.screens);

            var filter = new _ScanlinesFilter2.default(this._tvs.screens);
            this._tvs.screens.filters = [filter];

            if (webfont) {
                this._gameLabel = new PIXI.Text(translate("results_game_monitor"), { fontSize: "50px", fontFamily: "Arial", fill: 0xBF13A1, align: "center" });
                this._gameLabel.x = -150;
                this._gameLabel.y = -170;
                this._gameLabel.pivot.x = this._gameLabel.width * 0.5;
                this._tvs.screens.addChild(this._gameLabel);
            } else {
                this._gameLabel = new PIXI.extras.BitmapText(translate("results_game_monitor"), { font: "50px Cloudy Bold", align: "center" });
                this._gameLabel.x = -150;
                this._gameLabel.y = -170;
                this._gameLabel.pivot.x = this._gameLabel.textWidth * 0.5;
                this._gameLabel.tint = 0xBF13A1;
                this._tvs.screens.addChild(this._gameLabel);
            }

            if (webfont) {
                this._overLabel = new PIXI.Text(translate("results_over_monitor"), { fontSize: "50px", fontFamily: "Arial", fill: 0xEF041F, align: "center" });
                this._overLabel.x = 22;
                this._overLabel.y = -200;
                this._overLabel.pivot.x = this._overLabel.width * 0.5;
                this._tvs.screens.addChild(this._overLabel);
            } else {
                this._overLabel = new PIXI.extras.BitmapText(translate("results_over_monitor"), { font: "50px Cloudy Bold", align: "center" });
                this._overLabel.x = 22;
                this._overLabel.y = -200;
                this._overLabel.pivot.x = this._overLabel.textWidth * 0.5;
                this._overLabel.tint = 0xEF041F;
                this._tvs.screens.addChild(this._overLabel);
            }

            if (webfont) {
                this._scoreLabel = new PIXI.Text(translate("results_score_monitor"), { fontSize: "50px", fontFamily: "Arial", fill: 0xFFFFFF, align: "center" });
                this._scoreLabel.x = -180;
                this._scoreLabel.y = 20;
                this._scoreLabel.pivot.x = this._scoreLabel.width * 0.5;
                this._tvs.screens.addChild(this._scoreLabel);
            } else {
                this._scoreLabel = new PIXI.extras.BitmapText(translate("results_score_monitor"), { font: "50px Cloudy Bold", align: "center" });
                this._scoreLabel.x = -180;
                this._scoreLabel.y = 20;
                this._scoreLabel.pivot.x = this._scoreLabel.textWidth * 0.5;
                this._tvs.screens.addChild(this._scoreLabel);
            }

            if (webfont) {
                this._scoreValueLabel = new PIXI.Text(this._score.toString(), { fontSize: "60px", fontFamily: "Arial", fill: 0xFFFFFF, align: "center" });
                this._scoreValueLabel.x = -180;
                this._scoreValueLabel.y = 84;
                this._scoreValueLabel.pivot.x = this._scoreValueLabel.width * 0.5;
                this._tvs.screens.addChild(this._scoreValueLabel);
            } else {
                this._scoreValueLabel = new PIXI.extras.BitmapText(this._score.toString(), { font: "60px Cloudy 8bit2", align: "center" });
                this._scoreValueLabel.x = -180;
                this._scoreValueLabel.y = 84;
                this._scoreValueLabel.pivot.x = this._scoreValueLabel.textWidth * 0.5;
                this._tvs.screens.addChild(this._scoreValueLabel);
            }

            if (webfont) {
                this._bestLabel = new PIXI.Text(translate("results_best_monitor"), { fontSize: "50px", fontFamily: "Arial", fill: 0xFFFFFF, align: "center" });
                this._bestLabel.x = 124;
                this._bestLabel.y = 20 + 80;
                this._bestLabel.pivot.x = this._bestLabel.width * 0.5;
                this._tvs.screens.addChild(this._bestLabel);
            } else {
                this._bestLabel = new PIXI.extras.BitmapText(translate("results_best_monitor"), { font: "50px Cloudy Bold", align: "center" });
                this._bestLabel.x = 124;
                this._bestLabel.y = 20 + 80;
                this._bestLabel.pivot.x = this._bestLabel.textWidth * 0.5;
                this._tvs.screens.addChild(this._bestLabel);
            }

            if (webfont) {
                this._bestValueLabel = new PIXI.Text(_Common2.default.getHighscore().toString(), { fontSize: "60px", fontFamily: "Arial", fill: 0xFFFFFF, align: "center" });
                this._bestValueLabel.x = 124;
                this._bestValueLabel.y = 84 + 80;
                this._bestValueLabel.pivot.x = this._bestValueLabel.width * 0.5;
                this._tvs.screens.addChild(this._bestValueLabel);
            } else {
                this._bestValueLabel = new PIXI.extras.BitmapText(_Common2.default.getHighscore().toString(), { font: "60px Cloudy 8bit2", align: "center" });
                this._bestValueLabel.x = 124;
                this._bestValueLabel.y = 84 + 80;
                this._bestValueLabel.pivot.x = this._bestValueLabel.textWidth * 0.5;
                this._tvs.screens.addChild(this._bestValueLabel);
            }

            this._steve = new PIXI.Sprite(assets.getTexture("end_char_monkey"));
            this._steve.x = p3.View.width * 0.5 + 184;
            this._steve.y = _Common2.default.STAGE_HEIGHT * 0.5 - 340;
            this._steve.anchor = new PIXI.Point(0.5, 0.5);
            this._steve.visible = false;
            this.addChild(this._steve);

            this._flint = new PIXI.Sprite(assets.getTexture("end_char_flint"));
            this._flint.x = p3.View.width * 0.5 + 250;
            this._flint.y = _Common2.default.STAGE_HEIGHT * 0.5 - 20;
            this._flint.anchor = new PIXI.Point(0.5, 0.5);
            this._flint.visible = false;
            this.addChild(this._flint);

            var top = new PIXI.Sprite(assets.getTexture("end_gradient_top"));
            top.width = p3.View.width;
            this.addChild(top);

            var states = new p3.ButtonStates();
            states.normal = assets.getTexture("btn_small_off");
            states.icon = assets.getTexture("icon_replay_off");

            this._replayButton = new p3.Button(states);
            this._replayButton.visible = false;
            this._replayButton.overSoundName = "sfx_btn_press_00";
            this._replayButton.clickSoundName = "sfx_btn_home_00";
            this._replayButton.signals.click.add(this.onReplayButtonClick, this);
            this.addChild(this._replayButton);

            states = new p3.ButtonStates();
            states.normal = assets.getTexture("btn_small_off");
            states.icon = assets.getTexture("icon_home_off");

            this._homeButton = new p3.Button(states);
            this._homeButton.visible = false;
            this._homeButton.overSoundName = "sfx_btn_press_00";
            this._homeButton.clickSoundName = "sfx_btn_home_00";
            this._homeButton.signals.click.add(this.onNextButtonClick, this);
            this.addChild(this._homeButton);

            delay(function () {
                _Common2.default.audio.playSound(["sfx_results_reveal_01", "sfx_results_reveal_02", "sfx_results_reveal_03", "sfx_results_reveal_04", "sfx_results_reveal_05"]);
            }, 0.4, this);
        }
    }, {
        key: "destroy",
        value: function destroy() {
            _get(EndScene.prototype.__proto__ || Object.getPrototypeOf(EndScene.prototype), "destroy", this).call(this);
        }
    }, {
        key: "appear",
        value: function appear() {
            _get(EndScene.prototype.__proto__ || Object.getPrototypeOf(EndScene.prototype), "appear", this).call(this);
        }
    }, {
        key: "animateIn",
        value: function animateIn() {
            // next button
            this._homeButton.scale = new PIXI.Point();
            TweenMax.to(this._homeButton.scale, 0.34, {
                delay: 0.1,
                x: 1.0,
                y: 1.0,
                ease: Back.easeOut,
                easeParams: [2],
                onStart: function onStart() {
                    this._homeButton.visible = true;
                },
                onStartScope: this
            });

            // replay button
            this._replayButton.scale = new PIXI.Point();
            TweenMax.to(this._replayButton.scale, 0.34, {
                delay: 0.1 + 0.06,
                x: 1.0,
                y: 1.0,
                ease: Back.easeOut,
                easeParams: [2],
                onStart: function onStart() {
                    this._replayButton.visible = true;
                },
                onStartScope: this
            });

            // flint
            var to = this._flint.x;
            this._flint.x += 200;
            TweenMax.to(this._flint, 0.4, {
                x: to,
                ease: Back.easeOut,
                easeParams: [1],
                onStart: function onStart() {
                    this._flint.visible = true;
                },
                onStartScope: this
            });

            // steve
            to = new PIXI.Point(this._steve.x, this._steve.y);
            this._steve.x += 340;
            TweenMax.to(this._steve, 0.6, {
                delay: 0.24,
                bezier: [{ x: to.x + 180, y: to.y - 80 }, { x: to.x, y: to.y }],
                ease: Back.easeOut,
                easeParams: [1],
                onStart: function onStart() {
                    this._steve.visible = true;
                },
                onStartScope: this
            });
        }
    }, {
        key: "animateOut",
        value: function animateOut() {}
    }, {
        key: "resize",
        value: function resize() {
            this.y = (p3.View.height - _Common2.default.STAGE_HEIGHT) * 0.5;

            this._homeButton.x = 100;
            this._homeButton.y = (_Common2.default.STAGE_HEIGHT - p3.View.height) * 0.5 + 100;

            this._replayButton.x = p3.View.width - 100;
            this._replayButton.y = (_Common2.default.STAGE_HEIGHT + p3.View.height) * 0.5 - 100;

            this._emitter.updateOwnerPos(0.0, (_Common2.default.STAGE_HEIGHT - p3.View.height) * 0.5 - 20);
        }
    }, {
        key: "update",
        value: function update() {
            var filter = this._tvs.screens.filters[0];
            filter.time -= deltaTime * 4;

            this._emitter.update(deltaTime);
        }

        /**
         * @param {p3.Button} button
         */

    }, {
        key: "onReplayButtonClick",
        value: function onReplayButtonClick(button) {
            this.signals.next.dispatch(this);
        }

        /**
         * @param {p3.Button} button
         */

    }, {
        key: "onScoresButtonClick",
        value: function onScoresButtonClick(button) {}

        /**
         * @param {p3.Button} button
         */

    }, {
        key: "onNextButtonClick",
        value: function onNextButtonClick(button) {
            this.signals.home.dispatch(this);
        }
    }]);

    return EndScene;
}(p3.Scene);

exports.default = EndScene;

},{"./Common":11,"./ScanlinesFilter":24}],13:[function(require,module,exports){
/**
 *  GameScene
 *
 *  Created by Legman on 21/02/2017.
 *
 */

"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _Actor = require("./Actor");

var _Actor2 = _interopRequireDefault(_Actor);

var _Audio = require("./Audio");

var _Audio2 = _interopRequireDefault(_Audio);

var _AudioParams = require("./AudioParams");

var _AudioParams2 = _interopRequireDefault(_AudioParams);

var _Common = require("./Common");

var _Common2 = _interopRequireDefault(_Common);

var _GummyBear = require("./GummyBear");

var _GummyBear2 = _interopRequireDefault(_GummyBear);

var _Hud = require("./Hud");

var _Hud2 = _interopRequireDefault(_Hud);

var _Monkey = require("./Monkey");

var _Monkey2 = _interopRequireDefault(_Monkey);

var _PhysicsActor = require("./PhysicsActor");

var _PhysicsActor2 = _interopRequireDefault(_PhysicsActor);

var _Replicator = require("./Replicator");

var _Replicator2 = _interopRequireDefault(_Replicator);

var _Tile = require("./Tile1");

var _Tile2 = _interopRequireDefault(_Tile);

var _Tile3 = require("./Tile2");

var _Tile4 = _interopRequireDefault(_Tile3);

var _Tile5 = require("./Tile3");

var _Tile6 = _interopRequireDefault(_Tile5);

var _TileBg = require("./TileBg1");

var _TileBg2 = _interopRequireDefault(_TileBg);

var _TileBg3 = require("./TileBg2");

var _TileBg4 = _interopRequireDefault(_TileBg3);

var _ismobilejs = require("ismobilejs");

var _ismobilejs2 = _interopRequireDefault(_ismobilejs);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * @class
 */
var GameScene = function (_p3$Scene) {
    _inherits(GameScene, _p3$Scene);

    function GameScene() {
        _classCallCheck(this, GameScene);

        /**
         * @member {p3.Camera}
         * @private
         */
        var _this = _possibleConstructorReturn(this, (GameScene.__proto__ || Object.getPrototypeOf(GameScene)).call(this));

        _this._camera = null;

        /**
         * @member {PIXI.Container}
         * @private
         */
        _this._gameLayer = null;

        /**
         * @member {PIXI.Container}
         * @private
         */
        _this._tileLayer = null;

        /**
         * @member {PIXI.Container}
         * @private
         */
        _this._bgLayer = null;

        /**
         * @member {number}
         * @private
         */
        _this._bgParallax = 0.6;

        /**
         * @member {number}
         * @private
         */
        _this._bgParallaxInv = 1 / _this._bgParallax;

        /**
         * @member {Replicator}
         * @private
         */
        _this._replicator = null;

        /**
         * @member {Array.<Actor>}
         * @private
         */
        _this._bgTiles = null;

        /**
         * @member {number}
         * @private
         */
        _this._tileCount = 0;

        /**
         * @member {number}
         * @private
         */
        _this._bgTileCount = 0;

        /**
         * @member {number}
         * @private
         */
        _this._tileStartOffset = -530;

        /**
         * @member {number}
         * @private
         */
        _this._bgTileStartOffset = 600;

        /**
         * @member {number}
         * @private
         */
        _this._tileCreateOffset = 0;

        /**
         * @member {number}
         * @private
         */
        _this._bgTileCreateOffset = 0;

        /**
         * @member {number}
         * @private
         */
        _this._freezeOffset = 2;

        /**
         * @member {number}
         * @private
         */
        _this._animateCameraCount = 2;

        /**
         * @member {number}
         * @private
         */
        _this._increaseRangeCount = 5;

        /**
         * @member {Array.<Actor>}
         * @private
         */
        _this._actors = [];

        /**
         * @member {Array.<Monkey>}
         * @private
         */
        _this._monkeys = [];

        /**
         * @member {p2.Body}
         * @private
         */
        _this._floorBody = null;

        /**
         * @member {p2.Body}
         * @private
         */
        _this._wallBody = null;

        /**
         * @member {*}
         * @private
         */
        _this._floorPosition = new PIXI.Point(p3.View.width * 0.5, 110);

        /**
         * @member {boolean}
         * @private
         */
        _this._dropReady = true;

        /**
         * @member {boolean}
         * @private
         */
        _this._towerStable = true;

        /**
         * @member {Monkey}
         * @private
         */
        _this._topMonkey = null;

        /**
         * @member {Hud}
         * @private
         */
        _this._hud = null;

        /**
         * @member {PIXI.Sprite}
         * @private
         */
        _this._scoreTab = null;

        /**
         * @member {boolean}
         * @private
         */
        _this._gameOver = false;

        /**
         * @member {number}
         * @private
         */
        _this._score = 0;

        /**
         * @member {number}
         * @private
         */
        _this._scoreRangeMin = 10;

        /**
         * @member {number}
         * @private
         */
        _this._scoreRangeMax = 40;

        /**
         * @member {TimelineMax}
         * @private
         */
        _this._replicatorAnim = null;

        /**
         * @member {TimelineMax}
         * @private
         */
        _this._cameraAnim = null;

        /**
         * @member {TimelineMax}
         * @private
         */
        _this._scoreTabAnim = null;

        /**
         * @type {Audio}
         * @private
         */
        _this._ambientSFX = null;

        /**
         * @type {boolean}
         * @private
         */
        _this._isHighscore = false;

        /**
         * @type {TweenMax}
         * @private
         */
        _this._endDelay = null;
        return _this;
    }

    _createClass(GameScene, [{
        key: "init",
        value: function init() {
            _get(GameScene.prototype.__proto__ || Object.getPrototypeOf(GameScene.prototype), "init", this).call(this);

            this.createWorld();

            var assets = _Common2.default.assets;

            var bg = new PIXI.Sprite(assets.getTexture("bg_game"));
            this.addChild(bg);

            this._camera = new p3.Camera(new PIXI.Point(0, 1200));
            this._camera.trackEase = 0.04;
            _Common2.default.camera = this._camera;

            this._bgLayer = new PIXI.Container();
            this.addChild(this._bgLayer);

            this._tileLayer = new PIXI.Container();
            this.addChild(this._tileLayer);

            this._gameLayer = new PIXI.Container();
            this.addChild(this._gameLayer);

            var top = new PIXI.Sprite(assets.getTexture("gradient_top"));
            top.width = p3.View.width;
            this.addChild(top);

            var bottom = new PIXI.Sprite(assets.getTexture("gradient_btm"));
            bottom.y = _Common2.default.STAGE_HEIGHT;
            bottom.width = p3.View.width;
            bottom.anchor.y = 1;
            this.addChild(bottom);

            this._hit = new PIXI.Container();
            this._hit.hitArea = new PIXI.Rectangle();
            this.addChild(this._hit);

            this._hud = new _Hud2.default();
            this._hud.updateBestScore(_Common2.default.getHighscore());
            this._hud.pauseButton.signals.click.add(this.onPauseButtonClick, this);
            this.addChild(this._hud);

            this._camera.addLayer("game", this._gameLayer, new PIXI.Point(1, 1));
            this._camera.addLayer("tile", this._tileLayer, new PIXI.Point(1, 1));
            this._camera.addLayer("bg", this._bgLayer, new PIXI.Point(1, this._bgParallax));

            this._camera.trackTarget(new PIXI.Point(0, 0), true);

            var floor = new _Actor2.default(assets.getTexture("tile_000"));
            floor.y = this._tileStartOffset;
            floor.view.anchor = new PIXI.Point();
            this._tileLayer.addChild(floor);
            this._actors.push(floor);

            // first steve
            this._topMonkey = new _Monkey2.default();
            this._topMonkey.x = p3.View.width * 0.5;
            this._topMonkey.y = this._floorPosition.y - (this._topMonkey.body.shapes[0].height + this._floorBody.shapes[0].height) * 0.5;
            this._topMonkey.towerY = this._topMonkey.y - 10;
            this._topMonkey.body.type = p2.Body.KINEMATIC;
            this._gameLayer.addChild(this._topMonkey);
            this._monkeys.push(this._topMonkey);
            this._actors.push(this._topMonkey);

            this._replicator = new _Replicator2.default();
            this._replicator.x = p3.View.width * 0.5;
            this._replicator.y = -640;
            this._gameLayer.addChild(this._replicator);
            this._actors.push(this._replicator);

            this._scoreTab = new PIXI.Sprite(assets.getTexture("ui_score"));
            this._scoreTab.anchor = new PIXI.Point(0.0, 0.5);
            this._scoreTab.visible = false;
            this._gameLayer.addChild(this._scoreTab);

            this._scoreTab.label = new PIXI.extras.BitmapText("", { font: "60px Cloudy Bold", align: "center" });
            this._scoreTab.label.x = 72;
            this._scoreTab.label.pivot.y = this._scoreTab.label.textHeight * 0.5;
            this._scoreTab.addChild(this._scoreTab.label);

            this.updateScoreTab();

            this.createTile();
            this.createBgTile();

            this.playAmbientSFX();

            //this._isHighscore = this._score >= Common.getHighscore();
        }
    }, {
        key: "destroy",
        value: function destroy() {
            TweenMax.killAll();
            _Common2.default.world.clear();

            for (var i = 0; i < this._monkeys.length; ++i) {
                var monkey = this._monkeys[i];
                monkey.destroy();
            }
            this._monkeys.length = 0;

            this._replicator.destroy();

            this.stopAmbientSFX();

            _get(GameScene.prototype.__proto__ || Object.getPrototypeOf(GameScene.prototype), "destroy", this).call(this);
        }
    }, {
        key: "appear",
        value: function appear() {
            _get(GameScene.prototype.__proto__ || Object.getPrototypeOf(GameScene.prototype), "appear", this).call(this);

            this._hit.interactive = true;
            this._hit.click = this._hit.tap = this.onMouseClick.bind(this);

            _Common2.default.isFirstTime && this._hud.startIntroAnimation();
            _Common2.default.isFirstTime = false;

            delay(function () {
                this.signals.pause.dispatch(this);
            }, 0.5, this);
        }
    }, {
        key: "show",
        value: function show() {
            this._hit.interactive = true;
            this._hud.pauseButton.interactive = true;

            this.resumeGame();
        }
    }, {
        key: "hide",
        value: function hide() {
            this._hit.interactive = false;
            this._hud.pauseButton.interactive = false;
            this._hud.pauseButton.onMouseOut();
        }

        /**
         * @param {function} [callback]
         * @param {*} [scope]
         */

    }, {
        key: "animateIn",
        value: function animateIn(callback, scope) {
            this._hud.bestScore.scale = new PIXI.Point();
            TweenMax.to(this._hud.bestScore.scale, 0.34, {
                delay: 0.1,
                x: 1,
                y: 1,
                ease: Back.easeOut,
                easeParams: [1],
                onStart: function onStart() {
                    this._hud.bestScore.visible = true;
                },
                onStartScope: this
            });

            this._hud.pauseButton.scale = new PIXI.Point();
            TweenMax.to(this._hud.pauseButton.scale, 0.34, {
                delay: 0.1 + 0.06,
                x: 1,
                y: 1,
                ease: Back.easeOut,
                easeParams: [1],
                onStart: function onStart() {
                    this._hud.pauseButton.visible = true;
                },
                onStartScope: this
            });
        }

        /**
         * @param {function} [callback]
         * @param {*} [scope]
         */

    }, {
        key: "animateOut",
        value: function animateOut(callback, scope) {}
    }, {
        key: "end",
        value: function end() {
            this.signals.next.dispatch(this, this._score);

            _Common2.default.audio.playSound("sfx_game_over_00");

            console.log("gameover");
        }
    }, {
        key: "resize",
        value: function resize() {
            this.y = (p3.View.height - _Common2.default.STAGE_HEIGHT) * 0.5;
            this._hud.resize();

            this._hit.hitArea = new PIXI.Rectangle(0, (_Common2.default.STAGE_HEIGHT - p3.View.height) * 0.5 + 240, p3.View.width, p3.View.height - 240);
        }
    }, {
        key: "update",
        value: function update() {
            if (_Common2.default.paused) return;

            _Common2.default.world.step(_Common2.default.PHYSICS_TICK);
            this._camera.update();

            this._hud.update();

            for (var i = this._actors.length - 1; i >= 0; --i) {
                var actor = this._actors[i];
                if (actor.destroyNextFrame) {
                    this._actors.splice(i, 1);
                    actor.parent.removeChild(actor);
                    actor.destroy(true);
                } else actor.update();
            }

            this.updateTiles();

            // move the walls with the camera
            this._wallBody.position[1] = this._camera.position.y + this._camera.view.y;

            if (!this._gameOver) {
                if (!this._towerStable) {
                    var to = new p3.Vector2(this._replicator.x - this._topMonkey.x, this._replicator.y - this._topMonkey.y);
                    if (to.lengthSq > 340 * 340 && this.isTowerStable()) {
                        this._topMonkey.towerY = this._topMonkey.y - 10;
                        this._towerStable = true;

                        this.freezeTower();

                        var value = this.calculateScore();
                        if (value == 10) {
                            this.createGummyExplosion(new PIXI.Point(this._topMonkey.x, this._topMonkey.y - 80));

                            _Common2.default.audio.playSound("sfx_steve_land_perfect_03");
                            delay(function () {
                                language == "en" && _Common2.default.audio.playSound("sfx_steve_gummybears_00");
                            }, 0.4, this);
                        }

                        _Common2.default.audio.playSound(["sfx_steve_land_normal_00", "sfx_steve_land_normal_01", "sfx_steve_land_normal_02", "sfx_steve_land_normal_03", "sfx_steve_land_normal_04"]);

                        this._hud.animateScorePopup(value, new PIXI.Point(this._topMonkey.x + 134, this._topMonkey.y - _Common2.default.camera.position.y));

                        this._score += value;

                        this.updateScoreTab();
                        this.animateScoreTab();

                        if (this._score > _Common2.default.getHighscore()) {
                            this._hud.updateBestScore(this._score);
                            if (!this._isHighscore) {
                                this._isHighscore = true;
                                this._hud.animateBestScore();

                                _Common2.default.audio.playSound("sfx_new_highscore_01");
                            }
                        }

                        this.animateReplicator(function () {
                            this._replicator.moving = true;
                            this._replicator.charged = true;

                            this._dropReady = true;
                            this._replicator.mixUpSpeed();

                            if (this._monkeys.length % this._increaseRangeCount == this._increaseRangeCount - 1) {
                                this._replicator.increaseSpeedRange();
                            }
                        }, this);

                        if (this._monkeys.length % this._animateCameraCount == this._animateCameraCount - 1) {
                            this.animateCamera();
                        }
                    }
                }

                if (this.isTowerCollapsed()) {
                    this._gameOver = true;

                    this._endDelay && this._endDelay.kill();
                    this._endDelay = delay(this.end, 1, this);

                    _Common2.default.audio.playSound(["sfx_steve_fall_scream_00", "sfx_steve_fall_scream_01", "sfx_steve_fall_scream_02", "sfx_steve_fall_scream_03"]);
                }
            }
        }
    }, {
        key: "updateTiles",
        value: function updateTiles() {
            var y = void 0,
                tile = void 0;

            y = this._camera.target.y - this._camera.view.y - this._tileCreateOffset;
            if (y < 0) {
                this.createTile();
            }

            y = this._camera.target.y * this._bgParallax - this._camera.view.y - this._bgTileCreateOffset;
            if (y < 0) {
                this.createBgTile();
            }

            tile = this._tileLayer.children[0];
            if (tile.y - this._camera.position.y > _Common2.default.STAGE_HEIGHT) {
                this.destroyTile();
            }

            tile = this._bgLayer.children[0];
            if (tile.y * this._bgParallaxInv - this._camera.position.y > _Common2.default.STAGE_HEIGHT * this._bgParallaxInv) {
                this.destroyBgTile();
            }
        }
    }, {
        key: "createWorld",
        value: function createWorld() {
            var world = new p2.World({ gravity: [0, 420] });
            world.on("beginContact", this.onBeginContact, this);
            world.on("endContact", this.onEndContact, this);
            _Common2.default.world = world;

            world.solver.iterations = 20;
            world.defaultContactMaterial.friction = 1;
            world.defaultContactMaterial.restitution = 0;
            world.sleepMode = p2.World.BODY_SLEEPING;

            world.addContactMaterial(new p2.ContactMaterial(_PhysicsActor2.default.MATERIAL_DEFAULT, _PhysicsActor2.default.MATERIAL_GUMMY_BEAR, {
                restitution: 0.8
            }));

            this._floorBody = new p2.Body({ mass: 1 });
            this._floorBody.type = p2.Body.STATIC;
            this._floorBody.position = [this._floorPosition.x, this._floorPosition.y];
            this._floorBody.parent = this;
            _Common2.default.world.addBody(this._floorBody);

            var shape = void 0;
            shape = new p2.Box({ width: p3.View.width, height: 20 });
            shape.collisionGroup = _PhysicsActor2.default.DEFAULT;
            shape.collisionMask = _PhysicsActor2.default.DEFAULT | _PhysicsActor2.default.GUMMY_BEAR;
            shape.material = _PhysicsActor2.default.MATERIAL_DEFAULT;
            this._floorBody.addShape(shape);
            this._floorBody.updateMassProperties();

            this._wallBody = new p2.Body({ mass: 1 });
            this._wallBody.type = p2.Body.STATIC;
            this._wallBody.position = [p3.View.width * 0.5, 0];
            this._wallBody.parent = this;
            _Common2.default.world.addBody(this._wallBody);

            shape = new p2.Box({ width: 20, height: _Common2.default.STAGE_HEIGHT });
            shape.collisionGroup = _PhysicsActor2.default.DEFAULT;
            shape.collisionMask = _PhysicsActor2.default.GUMMY_BEAR;
            shape.material = _PhysicsActor2.default.MATERIAL_DEFAULT;
            this._wallBody.addShape(shape, [-p3.View.width * 0.5, 0]);

            shape = new p2.Box({ width: 20, height: _Common2.default.STAGE_HEIGHT });
            shape.collisionGroup = _PhysicsActor2.default.DEFAULT;
            shape.collisionMask = _PhysicsActor2.default.GUMMY_BEAR;
            shape.material = _PhysicsActor2.default.MATERIAL_DEFAULT;
            this._wallBody.addShape(shape, [p3.View.width * 0.5, 0]);

            this._wallBody.updateMassProperties();
        }
    }, {
        key: "createTile",
        value: function createTile() {
            var tiles = [_Tile2.default, _Tile4.default, _Tile6.default];
            var tile = new tiles[this._tileCount % tiles.length]();
            tile.y = this._tileStartOffset - ++this._tileCount * tile.view.texture.height;
            this._tileLayer.addChild(tile);
            this._actors.push(tile);

            this._tileCreateOffset = tile.y;
        }
    }, {
        key: "createBgTile",
        value: function createBgTile() {
            var tiles = [_TileBg2.default, _TileBg4.default];
            var tile = new tiles[this._bgTileCount % tiles.length]();
            tile.y = this._bgTileStartOffset - ++this._bgTileCount * tile.view.texture.height;
            this._bgLayer.addChild(tile);
            this._actors.push(tile);

            this._bgTileCreateOffset = tile.y;
        }
    }, {
        key: "destroyTile",
        value: function destroyTile() {
            var tile = this._tileLayer.children[0];
            tile.destroyNextFrame = true;
        }
    }, {
        key: "destroyBgTile",
        value: function destroyBgTile() {
            var tile = this._bgLayer.children[0];
            tile.destroyNextFrame = true;
        }

        /**
         * @param {boolean} [animate]
         * @returns {Monkey}
         */

    }, {
        key: "spawnMonkey",
        value: function spawnMonkey(animate) {
            var top = this._monkeys[this._monkeys.length - 1];
            var monkey = new _Monkey2.default();
            monkey.x = this._replicator.x;
            monkey.y = this._replicator.y + 320;
            this._gameLayer.addChildAt(monkey, top.parent.getChildIndex(top));
            this._monkeys.push(monkey);
            this._actors.push(monkey);

            if (animate) {
                monkey.body.type = p2.Body.KINEMATIC;
                monkey.syncToBody = false;

                var duration = 0.26;
                var to = monkey.y;
                monkey.y -= 180;
                TweenMax.to(monkey, duration, {
                    y: to,
                    ease: Power1.easeOut,
                    onComplete: function onComplete() {
                        monkey.body.type = p2.Body.DYNAMIC;
                        monkey.syncToBody = true;

                        _Common2.default.audio.playSound(language == "en" ? ["sfx_steve_00", "sfx_steve_01", "sfx_steve_can_00"] : ["sfx_steve_00", "sfx_steve_01"]);
                    },
                    onCompleteScope: this
                });

                monkey.scale = new PIXI.Point(0.34, 0.34);
                TweenMax.to(monkey.scale, duration, {
                    delay: 0.2,
                    x: 1,
                    ease: Back.easeOut,
                    easeParams: [2]
                });
                TweenMax.to(monkey.scale, duration * 0.6, {
                    delay: 0.2,
                    y: 1,
                    ease: Back.easeOut,
                    easeParams: [2]
                });
            }
            return monkey;
        }

        /**
         * @param {function} [callback]
         * @param {*} [scope]
         */

    }, {
        key: "animateReplicator",
        value: function animateReplicator(callback, scope) {
            this._replicatorAnim = new TimelineMax({ onComplete: callback, onCompleteScope: scope });

            var speed = 1100;
            var direction = Math.random() < 0.5 ? -1 : 1;
            var x = this._replicator.startPos.x - this._replicator.moveRange * direction;
            var dx = Math.abs(x - this._replicator.x);

            this._replicatorAnim.append(TweenMax.to(this._replicator, dx / speed, {
                x: x,
                ease: Power0.easeNone,
                onStart: function onStart() {
                    this._replicator.playMoveSFX();
                },
                onStartScope: this
            }));

            var y = this._replicator.y - this._topMonkey.body.shapes[0].height;
            var dy = Math.abs(y - this._replicator.y);
            this._replicatorAnim.append(TweenMax.to(this._replicator, dy / speed, {
                y: y,
                ease: Power0.easeNone,
                onStart: function onStart() {
                    this._replicator.playMoveUpSFX();
                },
                onStartScope: this
            }));
        }

        /**
         * @param {function} [callback]
         * @param {*} [scope]
         */

    }, {
        key: "animateCamera",
        value: function animateCamera(callback, scope) {
            this._cameraAnim = new TimelineMax();
            this._cameraAnim.insert(TweenMax.to(this._camera.target, 0.4, {
                y: this._topMonkey.y,
                ease: Power2.easeInOut,
                onComplete: callback,
                onCompleteScope: scope
            }));
        }

        /**
         * @param {function} [callback]
         * @param {*} [scope]
         */

    }, {
        key: "animateScoreTab",
        value: function animateScoreTab(callback, scope) {
            this._scoreTabAnim = new TimelineMax();

            if (!this._scoreTab.visible) {
                this._scoreTab.alpha = 0.0;
                this._scoreTabAnim.insert(TweenMax.to(this._scoreTab, 0.34, {
                    alpha: 1.0,
                    ease: Power1.easeInOut
                }));
            }

            this._scoreTabAnim.insert(TweenMax.to(this._scoreTab, 0.4, {
                y: this._topMonkey.y,
                ease: Back.easeOut,
                onStart: function onStart() {
                    this._scoreTab.visible = true;
                },
                onStartScope: this,
                onComplete: callback,
                onCompleteScope: scope
            }));
        }

        /**
         * @returns {number}
         */

    }, {
        key: "calculateScore",
        value: function calculateScore() {
            var value = 0;
            if (this._monkeys.length > 1) {
                var head = this._monkeys[this._monkeys.length - 2];
                var dx = Math.abs(head.x - this._topMonkey.x);
                value = Math.max(1, Math.floor((1 - Math.max(0, (dx - this._scoreRangeMin) / this._scoreRangeMax)) * 10));
            }
            return value;
        }
    }, {
        key: "updateScoreTab",
        value: function updateScoreTab() {
            this._scoreTab.label.text = this._score.toString();
            this._scoreTab.label.validate();
            this._scoreTab.label.pivot.x = this._scoreTab.label.textWidth * 0.5;
        }
    }, {
        key: "freezeTower",
        value: function freezeTower() {
            if (this._monkeys.length - this._freezeOffset > 0) {
                for (var i = 0; i < this._monkeys.length - this._freezeOffset; ++i) {
                    var body = this._monkeys[i].body;
                    body.type = p2.Body.KINEMATIC;
                }
            }
        }
    }, {
        key: "isTowerStable",
        value: function isTowerStable() {
            var average = 0;
            var count = 0;
            for (var i = 0; i < this._monkeys.length; ++i) {
                var monkey = this._monkeys[i];
                if (monkey.body.type == p2.Body.DYNAMIC) {
                    average += monkey.body.velocity[0] * monkey.body.velocity[0] + monkey.body.velocity[1] * monkey.body.velocity[1];
                    ++count;
                }
            }
            average /= count;
            return average < 10;
        }
    }, {
        key: "isTowerCollapsed",
        value: function isTowerCollapsed() {
            var result = false;
            if (this._monkeys.length > 1) {
                for (var i = 1; i < this._monkeys.length; ++i) {
                    var monkey = this._monkeys[i];
                    var head = this._monkeys[i - 1];
                    if (monkey.y > head.towerY) {
                        result = true;
                    }
                }
            }
            return result;
        }

        /**
         * @param {PIXI.Point} [position]
         */

    }, {
        key: "createGummyExplosion",
        value: function createGummyExplosion(position) {
            position = position || PIXI.Point;

            for (var i = 0; i < 14; ++i) {
                var force = new p3.Vector2();
                force.x = p3.Utils.randomRange(0.6, -0.6);
                force.y = p3.Utils.randomRange(-0.2, -0.6);

                var gummy = new _GummyBear2.default();
                gummy.x = position.x;
                gummy.y = position.y;
                gummy.rotation = Math.random() * (Math.PI * 2);
                this._gameLayer.addChildAt(gummy, this._scoreTab.parent.getChildIndex(this._scoreTab));
                this._actors.push(gummy);

                gummy.body.applyImpulse([force.x, force.y]);

                TweenMax.to(gummy.scale, 0.34, {
                    delay: 1.4 + Math.random(),
                    x: 0.0,
                    y: 0.0,
                    ease: Back.easeIn,
                    easeParams: [2],
                    onComplete: function onComplete(gummy) {
                        gummy.destroyNextFrame = true;
                    },
                    onCompleteParams: [gummy],
                    onCompleteScope: this
                });
            }
        }
    }, {
        key: "resumeGame",
        value: function resumeGame() {
            this._replicatorAnim && this._replicatorAnim.paused(false);
            this._cameraAnim && this._cameraAnim.paused(false);
            this._scoreTabAnim && this._scoreTabAnim.paused(false);
            this._endDelay && this._endDelay.paused(false);

            this._replicator.playMoveSFX();
            this.playAmbientSFX();
        }
    }, {
        key: "pauseGame",
        value: function pauseGame() {
            this._replicatorAnim && this._replicatorAnim.paused(true);
            this._cameraAnim && this._cameraAnim.paused(true);
            this._scoreTabAnim && this._scoreTabAnim.paused(true);
            this._endDelay && this._endDelay.paused(true);

            this._replicator.stopMoveSFX();
            this.stopAmbientSFX();
        }
    }, {
        key: "playAmbientSFX",
        value: function playAmbientSFX() {
            this.stopAmbientSFX();

            var params = new _AudioParams2.default();
            params.loop = true;

            this._ambientSFX = _Common2.default.audio.playSound("sfx_ambience_lab_00", params);
        }
    }, {
        key: "stopAmbientSFX",
        value: function stopAmbientSFX() {
            this._ambientSFX && this._ambientSFX.stop();
            this._ambientSFX = null;
        }

        /**
         * @param {p2.Event} event
         */

    }, {
        key: "onBeginContact",
        value: function onBeginContact(event) {
            var bodyA = event.bodyA;
            var bodyB = event.bodyB;

            if (bodyA.parent instanceof _PhysicsActor2.default && !bodyA.parent.hit) {
                bodyA.parent.onBeginContact(bodyB);
            }
            if (bodyB.parent instanceof _PhysicsActor2.default && !bodyB.parent.hit) {
                bodyB.parent.onBeginContact(bodyA);
            }
        }

        /**
         * @param {p2.Event} event
         */

    }, {
        key: "onEndContact",
        value: function onEndContact(event) {
            var bodyA = event.bodyA;
            var bodyB = event.bodyB;

            if (bodyA.parent instanceof _PhysicsActor2.default && bodyA.parent.hit) {
                bodyA.parent.onEndContact(bodyB);
            }
            if (bodyB.parent instanceof _PhysicsActor2.default && bodyB.parent.hit) {
                bodyB.parent.onEndContact(bodyA);
            }
        }

        /**
         * @param {Event} event
         */

    }, {
        key: "onMouseClick",
        value: function onMouseClick(event) {
            if (!this._dropReady || this._gameOver) return;

            this._hud.stopIntroAnimation();

            this._topMonkey && (this._topMonkey.onTop = false);

            this._topMonkey = this.spawnMonkey(true);
            this._topMonkey.playSpawnState();

            this._replicator.animate();
            this._replicator.moving = false;
            this._replicator.charged = false;
            this._replicator.stopMoveSFX();

            this._dropReady = false;
            this._towerStable = false;

            _Common2.default.audio.playSound(["sfx_clone_zap_00", "sfx_clone_zap_01"]);
        }

        /**
         * @param {p3.Button} button
         */

    }, {
        key: "onPauseButtonClick",
        value: function onPauseButtonClick(button) {
            this.signals.pause.dispatch(this);
        }
    }]);

    return GameScene;
}(p3.Scene);

exports.default = GameScene;

},{"./Actor":3,"./Audio":5,"./AudioParams":7,"./Common":11,"./GummyBear":14,"./Hud":16,"./Monkey":20,"./PhysicsActor":22,"./Replicator":23,"./Tile1":26,"./Tile2":27,"./Tile3":28,"./TileBg1":29,"./TileBg2":30,"ismobilejs":2}],14:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _Common = require("./Common");

var _Common2 = _interopRequireDefault(_Common);

var _PhysicsActor2 = require("./PhysicsActor");

var _PhysicsActor3 = _interopRequireDefault(_PhysicsActor2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /**
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *  GummyBear
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *  Created by Legman on 22/02/2017.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */

/**
 * @class
 */
var GummyBear = function (_PhysicsActor) {
    _inherits(GummyBear, _PhysicsActor);

    function GummyBear() {
        _classCallCheck(this, GummyBear);

        var assets = _Common2.default.assets;
        var textures = ["gummybear_000", "gummybear_001", "gummybear_002", "gummybear_003", "gummybear_004", "gummybear_005", "gummybear_006"];

        return _possibleConstructorReturn(this, (GummyBear.__proto__ || Object.getPrototypeOf(GummyBear)).call(this, assets.getTexture(textures[Math.floor(Math.random() * textures.length)])));
    }

    _createClass(GummyBear, [{
        key: "init",
        value: function init() {
            _get(GummyBear.prototype.__proto__ || Object.getPrototypeOf(GummyBear.prototype), "init", this).call(this);

            TweenMax.to(this.view.scale, 0.24, {
                x: 0.96,
                ease: Power1.easeInOut,
                yoyo: true,
                repeat: -1
            });

            TweenMax.to(this.view.scale, 0.34, {
                y: 0.88,
                ease: Power1.easeInOut,
                yoyo: true,
                repeat: -1
            });
        }

        /**
         * @param {boolean} [destroyChildren]
         */

    }, {
        key: "destroy",
        value: function destroy(destroyChildren) {
            TweenMax.killTweensOf(this.view.scale);

            _get(GummyBear.prototype.__proto__ || Object.getPrototypeOf(GummyBear.prototype), "destroy", this).call(this, destroyChildren);
        }

        /**
         * @returns {p2.Body}
         */

    }, {
        key: "createBody",
        value: function createBody() {
            var body = new p2.Body({ mass: 0.001 });
            body.type = p2.Body.DYNAMIC;
            body.allowSleep = true;
            body.sleepSpeedLimit = 4.0;
            body.parent = this;

            var shape = new p2.Box({ width: 16, height: 34 });
            shape.collisionGroup = _PhysicsActor3.default.GUMMY_BEAR;
            shape.collisionMask = _PhysicsActor3.default.DEFAULT;
            shape.material = _PhysicsActor3.default.MATERIAL_GUMMY_BEAR;

            body.addShape(shape);
            return body;
        }
    }]);

    return GummyBear;
}(_PhysicsActor3.default);

exports.default = GummyBear;

},{"./Common":11,"./PhysicsActor":22}],15:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _Common = require("./Common");

var _Common2 = _interopRequireDefault(_Common);

var _ScanlinesFilter = require("./ScanlinesFilter");

var _ScanlinesFilter2 = _interopRequireDefault(_ScanlinesFilter);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /**
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *  HelpScene
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *  Created by Legman on 24/02/2017.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */

/**
 * @class
 */
var HelpScene = function (_p3$Scene) {
    _inherits(HelpScene, _p3$Scene);

    function HelpScene() {
        _classCallCheck(this, HelpScene);

        /**
         * @member {PIXI.Sprite}
         * @private
         */
        var _this = _possibleConstructorReturn(this, (HelpScene.__proto__ || Object.getPrototypeOf(HelpScene)).call(this));

        _this._panel = null;

        /**
         * @member {PIXI.Sprite}
         * @private
         */
        _this._info = null;

        /**
         * @member {p3.Button}
         * @private
         */
        _this._backButton = null;
        return _this;
    }

    _createClass(HelpScene, [{
        key: "init",
        value: function init() {
            _get(HelpScene.prototype.__proto__ || Object.getPrototypeOf(HelpScene.prototype), "init", this).call(this);

            var assets = _Common2.default.assets;

            var bg = new PIXI.Sprite(assets.getTexture("paused_overlay"));
            bg.width = p3.View.width;
            this.addChild(bg);

            this._panel = new PIXI.Sprite(assets.getTexture("paused_panel"));
            this._panel.x = p3.View.width * 0.5;
            this._panel.y = 100;
            this._panel.anchor.x = 0.5;
            this._panel.visible = false;
            this.addChild(this._panel);

            this._panel.stem = new PIXI.Sprite(assets.getTexture("paused_panel_stem"));
            this._panel.stem.anchor.x = 0.5;
            this._panel.addChild(this._panel.stem);

            this._panel.image = new PIXI.Sprite(assets.getTexture("instructions_screen"));
            this._panel.image.x = -14;
            this._panel.image.y = 862;
            this._panel.image.anchor = new PIXI.Point(0.5, 0.5);
            this._panel.image.visible = false;
            this._panel.addChild(this._panel.image);

            var filter = new _ScanlinesFilter2.default(this._panel.image);
            this._panel.image.filters = [filter];

            this._info = new PIXI.Sprite(assets.getTexture("instructions_info"));
            this._info.x = p3.View.width * 0.5;
            this._info.y = _Common2.default.STAGE_HEIGHT * 0.5 + 400;
            this._info.anchor = new PIXI.Point(0.5, 0.5);
            this._info.visible = false;
            this.addChild(this._info);

            var states = new p3.ButtonStates();
            states.normal = assets.getTexture("btn_small_off");
            states.icon = assets.getTexture("icon_close_off");

            this._backButton = new p3.Button(states);
            this._backButton.visible = false;
            this._backButton.signals.click.add(this.onBackButtonClick, this);
            this.addChild(this._backButton);
        }
    }, {
        key: "destroy",
        value: function destroy() {
            _get(HelpScene.prototype.__proto__ || Object.getPrototypeOf(HelpScene.prototype), "destroy", this).call(this);
        }
    }, {
        key: "appear",
        value: function appear() {
            _get(HelpScene.prototype.__proto__ || Object.getPrototypeOf(HelpScene.prototype), "appear", this).call(this);
        }

        /**
         * @param {function} [callback]
         * @param {*} [scope]
         */

    }, {
        key: "animateIn",
        value: function animateIn(callback, scope) {
            // panel
            var to = this._panel.y;
            this._panel.y = -this._panel.height;
            TweenMax.to(this._panel, 0.4, {
                delay: 0.1,
                y: to,
                ease: Back.easeOut,
                easeParams: [0.8],
                onStart: function onStart() {
                    this._panel.visible = true;
                },
                onStartScope: this,
                onComplete: function onComplete() {
                    // panel screen
                    this._panel.image.scale.y = 0;
                    TweenMax.to(this._panel.image.scale, 0.14, {
                        y: 1,
                        ease: Power2.easeInOut,
                        onStart: function onStart() {
                            this._panel.image.visible = true;
                        },
                        onStartScope: this
                    });
                    this._panel.image.alpha = 0;
                    TweenMax.to(this._panel.image, 0.1, {
                        alpha: 1,
                        ease: Power1.easeInOut
                    });
                },
                onCompleteScope: this
            });

            // back button
            this._backButton.scale = new PIXI.Point();
            TweenMax.to(this._backButton.scale, 0.34, {
                delay: 0.1,
                x: 1.0,
                y: 1.0,
                ease: Back.easeOut,
                easeParams: [2],
                onStart: function onStart() {
                    this._backButton.visible = true;
                },
                onStartScope: this
            });
        }

        /**
         * @param {function} [callback]
         * @param {*} [scope]
         */

    }, {
        key: "animateOut",
        value: function animateOut(callback, scope) {}
    }, {
        key: "resize",
        value: function resize() {
            this.y = (p3.View.height - _Common2.default.STAGE_HEIGHT) * 0.5;

            this._backButton.x = p3.View.width - 100;
            this._backButton.y = (_Common2.default.STAGE_HEIGHT - p3.View.height) * 0.5 + 100;
        }
    }, {
        key: "update",
        value: function update() {
            var filter = this._panel.image.filters[0];
            filter.time -= deltaTime * 4;
        }

        /**
         * @param {p3.Button} button
         */

    }, {
        key: "onBackButtonClick",
        value: function onBackButtonClick(button) {
            this.signals.next.dispatch(this);
        }
    }]);

    return HelpScene;
}(p3.Scene);

exports.default = HelpScene;

},{"./Common":11,"./ScanlinesFilter":24}],16:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _Common = require("./Common");

var _Common2 = _interopRequireDefault(_Common);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /**
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *  Hud
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *  Created by Legman on 23/02/2017.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */

/**
 * @class
 */
var Hud = function (_PIXI$Container) {
    _inherits(Hud, _PIXI$Container);

    function Hud() {
        _classCallCheck(this, Hud);

        var _this = _possibleConstructorReturn(this, (Hud.__proto__ || Object.getPrototypeOf(Hud)).call(this));

        var assets = _Common2.default.assets;

        /**
         * @member {PIXI.Sprite}
         * @private
         */
        _this._hand = new PIXI.Sprite(assets.getTexture("tutorial_hand"));
        _this._hand.x = _Common2.default.STAGE_WIDTH * 0.5 + 60;
        _this._hand.y = _Common2.default.STAGE_HEIGHT * 0.5 + 40;
        _this._hand.anchor = new PIXI.Point(0.5, 0.5);
        _this._hand.hitArea = new PIXI.Rectangle();
        _this._hand.visible = false;
        _this.addChild(_this._hand);

        /**
         * @member {PIXI.Sprite}
         * @private
         */
        _this._bestScore = new PIXI.Sprite(assets.getTexture("ui_best"));
        _this._bestScore.anchor = new PIXI.Point(0.5, 0.5);
        _this._bestScore.hitArea = new PIXI.Rectangle();
        _this._bestScore.visible = false;
        _this.addChild(_this._bestScore);

        if (webfont) {
            _this._bestScore.title = new PIXI.Text(translate("game_best_score"), { fontSize: "42px", fontFamily: "Arial", fill: "0xFFFFFF", align: "center" });
            _this._bestScore.title.y = -42;
            _this._bestScore.title.pivot.x = _this._bestScore.title.width * 0.5;
            _this._bestScore.title.pivot.y = _this._bestScore.title.height;
            _this._bestScore.addChild(_this._bestScore.title);
        } else {
            _this._bestScore.title = new PIXI.extras.BitmapText(translate("game_best_score"), { font: "42px Cloudy Bold", align: "center" });
            _this._bestScore.title.y = -42;
            _this._bestScore.title.pivot.x = _this._bestScore.title.textWidth * 0.5;
            _this._bestScore.title.pivot.y = _this._bestScore.title.textHeight;
            _this._bestScore.addChild(_this._bestScore.title);
        }

        if (webfont) {
            _this._bestScore.score = new PIXI.Text("0", { fontSize: "60px", fontFamily: "Arial", fill: "0xFFFFFF", align: "center" });
            _this._bestScore.score.pivot.x = _this._bestScore.score.width * 0.5;
            _this._bestScore.score.pivot.y = _this._bestScore.score.height * 0.5;
            _this._bestScore.addChild(_this._bestScore.score);
        } else {
            _this._bestScore.score = new PIXI.extras.BitmapText("0", { font: "60px Cloudy Bold", align: "center" });
            _this._bestScore.score.pivot.x = _this._bestScore.score.textWidth * 0.5;
            _this._bestScore.score.pivot.y = _this._bestScore.score.textHeight * 0.5;
            _this._bestScore.addChild(_this._bestScore.score);
        }

        var config = assets.getJSON("best");
        _this._bestScore.emitter = new PIXI.particles.Emitter(_this._bestScore, [assets.getTexture("particle_replicator_001")], config);
        _this._bestScore.emitter.emit = false;

        var states = new p3.ButtonStates();
        states.normal = assets.getTexture("btn_small_off");
        states.icon = assets.getTexture("icon_pause_off");

        _this._pauseButton = new p3.Button(states);
        _this._pauseButton.visible = false;
        _this._pauseButton.overSoundName = "sfx_btn_press_00";
        _this._pauseButton.clickSoundName = "sfx_btn_home_00";
        _this.addChild(_this._pauseButton);

        _this.on("added", _this.init, _this);
        return _this;
    }

    _createClass(Hud, [{
        key: "init",
        value: function init() {
            this.off("added", this.init);
        }
    }, {
        key: "destroy",
        value: function destroy(destroyChildren) {
            this._bestScore.emitter.clear();

            _get(Hud.prototype.__proto__ || Object.getPrototypeOf(Hud.prototype), "destroy", this).call(this, destroyChildren);
        }
    }, {
        key: "update",
        value: function update() {
            this._bestScore.emitter.update(deltaTime);
        }
    }, {
        key: "resize",
        value: function resize() {
            this._bestScore.x = 120;
            this._bestScore.y = (_Common2.default.STAGE_HEIGHT - p3.View.height) * 0.5 + 100;

            this._pauseButton.x = p3.View.width - 100;
            this._pauseButton.y = (_Common2.default.STAGE_HEIGHT - p3.View.height) * 0.5 + 100;
        }

        /**
         * @param {!number} value
         * @param {PIXI.Point} position
         * @param {function} [callback]
         * @param {*} [scope]
         */

    }, {
        key: "animateScorePopup",
        value: function animateScorePopup(value, position, callback, scope) {
            var popup = new PIXI.Container();
            popup.x = position.x;
            popup.y = position.y;
            this.addChildAt(popup, 0);

            popup.label = new PIXI.extras.BitmapText(translate("game_score_popup").replace("[VALUE]", value), { font: "60px Cloudy Bold", align: "center" });
            popup.label.pivot.x = popup.label.textWidth * 0.5;
            popup.label.pivot.y = popup.label.textHeight * 1.4;
            popup.addChild(popup.label);

            var tl = new TimelineMax({ onComplete: function onComplete() {
                    popup.parent.removeChild(parent);
                    popup.destroy();

                    callback && callback.call(scope);
                }, onCompleteScope: this });

            popup.scale = new PIXI.Point();
            tl.append(TweenMax.to(popup.scale, 0.32, {
                x: 1,
                y: 1,
                ease: Back.easeOut,
                easeParams: [3]
            }));
            tl.append(TweenMax.to(popup, 0.2, {
                alpha: 0.0,
                ease: Power1.easeInOut
            }));
        }
    }, {
        key: "animateBestScore",
        value: function animateBestScore() {
            this._bestScore.emitter.emit = true;

            TweenMax.killTweensOf(this._bestScore.scale);

            var tl = new TimelineMax();
            tl.append(TweenMax.to(this._bestScore.scale, 0.2, {
                x: 1.16,
                y: 1.16,
                ease: Power0.easeNone
            }));
            tl.append(TweenMax.to(this._bestScore.scale, 0.16, {
                x: 1,
                y: 1,
                ease: Power2.easeInOut
            }));
        }

        /**
         * @param {!number} value
         */

    }, {
        key: "updateBestScore",
        value: function updateBestScore(value) {
            this._bestScore.score.text = value.toString();
            if (webfont) {
                this._bestScore.score.pivot.x = this._bestScore.score.width * 0.5;
            } else {
                this._bestScore.score.pivot.x = this._bestScore.score.textWidth * 0.5;
            }
        }
    }, {
        key: "startIntroAnimation",
        value: function startIntroAnimation() {
            this._hand.alpha = 0;
            TweenMax.to(this._hand, 0.2, {
                delay: 0.2,
                alpha: 1,
                ease: Power1.easeInOut,
                onStart: function onStart() {
                    this._hand.visible = true;
                },
                onStartScope: this
            });

            var tl = new TimelineMax({ delay: 1, repeat: -1 });
            tl.insert(TweenMax.to(this._hand.scale, 0.2, {
                x: 0.9,
                y: 0.9,
                ease: Back.easeOut,
                yoyo: true,
                repeat: 1
            }));
            tl.insert(TweenMax.delayedCall(1.4, function () {}));
        }
    }, {
        key: "stopIntroAnimation",
        value: function stopIntroAnimation() {
            TweenMax.to(this._hand, 0.2, {
                alpha: 0,
                ease: Power1.easeInOut,
                onComplete: function onComplete() {
                    TweenMax.killTweensOf(this._hand);
                    this._hand.visible = false;
                },
                onCompleteScope: this
            });
        }

        /**
         * @returns PIXI.Sprite
         */

    }, {
        key: "bestScore",
        get: function get() {
            return this._bestScore;
        }

        /**
         * @returns {p3.Button}
         */

    }, {
        key: "pauseButton",
        get: function get() {
            return this._pauseButton;
        }
    }]);

    return Hud;
}(PIXI.Container);

exports.default = Hud;

},{"./Common":11}],17:[function(require,module,exports){
/**
 *  Input
 *
 *  Created by Legman on 8/10/2015.
 *
 */

"use strict";

/**
 * @constructor
 */

function Input() {
  /**
   * @type {boolean}
   */
  this.isKeyUp = false;

  /**
   * @type {boolean}
   */
  this.isKeyLeft = false;

  /**
   * @type {boolean}
   */
  this.isKeyRight = false;

  /**
   * @type {boolean}
   */
  this.isKeyDown = false;

  /**
   * @type {boolean}
   */
  this.isKeyFire = false;

  /**
   * @type {boolean}
   */
  this.isKeyAltFire = false;

  /**
   * @type {PIXI.Point}
   */
  this.touch = new PIXI.Point();

  /**
   * @type {boolean}
   */
  this.isTouch = false;

  /**
   * @type {*}
   */
  this.signals = {};
  this.signals.mouseMove = new signals.Signal();
  this.signals.mouseDown = new signals.Signal();
  this.signals.mouseUp = new signals.Signal();
  this.signals.mouseOut = new signals.Signal();
  this.signals.mouseClick = new signals.Signal();

  this.signals.keyDown = new signals.Signal();
  this.signals.keyUp = new signals.Signal();

  /**
   * @type {null}
   * @private
   */
  this._stage = null;
}
module.exports = Input;

/**
 * @type {*}
 */
Input.keys = {};

/**
 * @type {number}
 * @static
 * @const
 */
Input.keys.W = 87;

/**
 * @type {number}
 * @static
 * @const
 */
Input.keys.A = 65;

/**
 * @type {number}
 * @static
 * @const
 */
Input.keys.S = 83;

/**
 * @type {number}
 * @static
 * @const
 */
Input.keys.D = 68;

/**
 * @type {number}
 * @static
 * @const
 */
Input.keys.Z = 90;

/**
 * @type {number}
 * @static
 * @const
 */
Input.keys.X = 88;

/**
 * @type {number}
 * @static
 * @const
 */
Input.keys.C = 67;

/**
 * @type {number}
 * @static
 * @const
 */
Input.keys.SPACE = 32;

/**
 * @type {number}
 * @static
 * @const
 */
Input.keys.LEFT = 37;

/**
 * @type {number}
 * @static
 * @const
 */
Input.keys.RIGHT = 39;

/**
 * @type {number}
 * @static
 * @const
 */
Input.keys.UP = 38;

/**
 * @type {number}
 * @static
 * @const
 */
Input.keys.DOWN = 40;

/**
 * @type {number}
 * @static
 * @const
 */
Input.keys.ENTER = 13;

/**
 * @param {!PIXI.DisplayObject} stage
 * @param {!*} keyListener
 */
Input.prototype.init = function (stage, keyListener) {
  this._stage = stage;
  this._stage.interactive = true;
  this._stage.mousemove = this._stage.touchmove = this.onMouseMove.bind(this);
  this._stage.mousedown = this._stage.touchstart = this.onMouseDown.bind(this);
  this._stage.mouseup = this._stage.touchend = this.onMouseUp.bind(this);
  this._stage.mouseout = this.onMouseOut.bind(this);
  this._stage.click = this._stage.tap = this.onMouseClick.bind(this);

  keyListener.onkeydown = this.onKeyDown.bind(this);
  keyListener.onkeyup = this.onKeyUp.bind(this);
  keyListener.focus();
};

Input.prototype.dispose = function () {
  this._stage.mousemove = this._stage.touchmove = null;
  this._stage.mousedown = this._stage.touchstart = null;
  this._stage.mouseup = this._stage.touchend = null;
  this._stage.mouseout = null;
  this._stage.click = this._stage.tap = null;

  this.signals.mouseMove.dispose();
  this.signals.mouseDown.dispose();
  this.signals.mouseUp.dispose();
  this.signals.mouseOut.dispose();
  this.signals.mouseClick.dispose();

  this.signals.keyDown.dispose();
  this.signals.keyUp.dispose();
};

/**
 * @param {!Event} event
 */
Input.prototype.onMouseMove = function (event) {
  this.touch = event.data.getLocalPosition(this._stage);
  p3.Timestep.queueCall(function () {
    this.signals.mouseMove.dispatch(event);
  }, [], this);
};

/**
 * @param {!Event} event
 */
Input.prototype.onMouseDown = function (event) {
  this.touch = event.data.getLocalPosition(this._stage);
  this.isTouch = true;

  p3.Timestep.queueCall(function () {
    this.signals.mouseDown.dispatch(event);
  }, [], this);
};

/**
 * @param {!Event} event
 */
Input.prototype.onMouseUp = function (event) {
  this.touch = event.data.getLocalPosition(this._stage);
  this.isTouch = false;

  p3.Timestep.queueCall(function () {
    this.signals.mouseUp.dispatch(event);
  }, [], this);
};

/**
 * @param {!Event} event
 */
Input.prototype.onMouseOut = function (event) {
  this.touch = event.data.getLocalPosition(this._stage);
  this.isTouch = false;

  p3.Timestep.queueCall(function () {
    this.signals.mouseOut.dispatch(event);
  }, [], this);
};

/**
 * @param {!Event} event
 */
Input.prototype.onMouseClick = function (event) {
  p3.Timestep.queueCall(function () {
    this.signals.mouseClick.dispatch(event);
  }, [], this);
};

/**
 * @param {!Event} event
 */
Input.prototype.onKeyDown = function (event) {
  switch (event.keyCode) {
    case Input.keys.UP:
    case Input.keys.W:
      {
        this.isKeyUp = true;
        break;
      }
    case Input.keys.LEFT:
    case Input.keys.A:
      {
        this.isKeyLeft = true;
        break;
      }
    case Input.keys.RIGHT:
    case Input.keys.D:
      {
        this.isKeyRight = true;
        break;
      }
    case Input.keys.DOWN:
    case Input.keys.S:
      {
        this.isKeyDown = true;
        break;
      }
    case Input.keys.Z:
    case Input.keys.SPACE:
      {
        this.isKeyFire = true;
        break;
      }
    case Input.keys.X:
      {
        this.isKeyAltFire = true;
        break;
      }
  }

  p3.Timestep.queueCall(function () {
    this.signals.keyDown.dispatch(event);
  }, [], this);
};

/**
 * @param {!Event} event
 */
Input.prototype.onKeyUp = function (event) {
  switch (event.keyCode) {
    case Input.keys.UP:
    case Input.keys.W:
      {
        this.isKeyUp = false;
        break;
      }
    case Input.keys.LEFT:
    case Input.keys.A:
      {
        this.isKeyLeft = false;
        break;
      }
    case Input.keys.RIGHT:
    case Input.keys.D:
      {
        this.isKeyRight = false;
        break;
      }
    case Input.keys.DOWN:
    case Input.keys.S:
      {
        this.isKeyDown = false;
        break;
      }
    case Input.keys.Z:
    case Input.keys.SPACE:
      {
        this.isKeyFire = false;
        break;
      }
    case Input.keys.X:
      {
        this.isKeyAltFire = false;
        break;
      }
  }

  p3.Timestep.queueCall(function () {
    this.signals.keyUp.dispatch(event);
  }, [], this);
};

},{}],18:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _Common = require("./Common");

var _Common2 = _interopRequireDefault(_Common);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /**
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *  EndScene
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *  Created by Legman on 16/03/2017.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */

/**
 * @class
 */
var IntroScene = function (_p3$Scene) {
    _inherits(IntroScene, _p3$Scene);

    function IntroScene() {
        _classCallCheck(this, IntroScene);

        /**
         * @member {PIXI.Sprite}
         * @private
         */
        var _this = _possibleConstructorReturn(this, (IntroScene.__proto__ || Object.getPrototypeOf(IntroScene)).call(this));

        _this._intro1 = null;

        /**
         * @member {PIXI.Sprite}
         * @private
         */
        _this._intro2 = null;

        /**
         * @member {PIXI.Sprite}
         * @private
         */
        _this._intro3 = null;

        /**
         * @member {p3.Button}
         * @private
         */
        _this._nextButton = null;

        /**
         * @member {Audio}
         * @private
         */
        _this._introSFX = null;
        return _this;
    }

    _createClass(IntroScene, [{
        key: "init",
        value: function init() {
            _get(IntroScene.prototype.__proto__ || Object.getPrototypeOf(IntroScene.prototype), "init", this).call(this);

            var assets = _Common2.default.assets;

            var bg = new PIXI.Sprite(assets.getTexture("bg_intro"));
            this.addChild(bg);

            this._intro1 = new PIXI.Sprite(assets.getTexture("intro_top"));
            this._intro1.x = _Common2.default.STAGE_WIDTH * 0.5;
            this._intro1.y = _Common2.default.STAGE_HEIGHT * 0.5 - this._intro1.texture.height;
            this._intro1.anchor = new PIXI.Point(0.5, 0.5);
            this._intro1.visible = false;
            this.addChild(this._intro1);

            this._intro2 = new PIXI.Sprite(assets.getTexture("intro_mid"));
            this._intro2.x = _Common2.default.STAGE_WIDTH * 0.5;
            this._intro2.y = _Common2.default.STAGE_HEIGHT * 0.5 - 8;
            this._intro2.anchor = new PIXI.Point(0.5, 0.5);
            this._intro2.visible = false;
            this.addChild(this._intro2);

            this._intro3 = new PIXI.Sprite(assets.getTexture("intro_btm"));
            this._intro3.x = _Common2.default.STAGE_WIDTH * 0.5;
            this._intro3.y = _Common2.default.STAGE_HEIGHT * 0.5 + this._intro3.texture.height + 12;
            this._intro3.anchor = new PIXI.Point(0.5, 0.5);
            this._intro3.visible = false;
            this.addChild(this._intro3);

            var states = new p3.ButtonStates();
            states.normal = assets.getTexture("btn_small_off");
            states.icon = assets.getTexture("icon_play_off");

            this._nextButton = new p3.Button(states);
            this._nextButton.visible = false;
            this._nextButton.overSoundName = "sfx_btn_press_00";
            this._nextButton.clickSoundName = "sfx_btn_home_00";
            this._nextButton.signals.click.add(this.onNextButtonClick, this);
            this.addChild(this._nextButton);

            this._introSFX = _Common2.default.audio.playSound("sfx_game_play_cpu_intro_00");
        }
    }, {
        key: "destroy",
        value: function destroy() {
            this._introSFX.stop();

            _get(IntroScene.prototype.__proto__ || Object.getPrototypeOf(IntroScene.prototype), "destroy", this).call(this);
        }
    }, {
        key: "appear",
        value: function appear() {
            _get(IntroScene.prototype.__proto__ || Object.getPrototypeOf(IntroScene.prototype), "appear", this).call(this);
        }
    }, {
        key: "animateIn",
        value: function animateIn() {
            var tl = new TimelineMax();

            var delay = 0.64;

            var to = this._intro1.x;
            this._intro1.x -= p3.View.width;
            tl.append(TweenMax.to(this._intro1, 0.2, {
                x: to,
                ease: Power2.easeOut,
                onStart: function onStart() {
                    this._intro1.visible = true;
                    _Common2.default.audio.playSound("sfx_tv_help_static_00");
                },
                onStartScope: this
            }));

            to = this._intro2.x;
            this._intro2.x += p3.View.width;
            tl.append(TweenMax.to(this._intro2, 0.2, {
                delay: delay,
                x: to,
                ease: Power2.easeOut,
                onStart: function onStart() {
                    this._intro2.visible = true;
                    _Common2.default.audio.playSound("sfx_tv_help_static_00");
                },
                onStartScope: this
            }));

            to = this._intro3.x;
            this._intro3.x -= p3.View.width;
            tl.append(TweenMax.to(this._intro3, 0.2, {
                delay: delay,
                x: to,
                ease: Power2.easeOut,
                onStart: function onStart() {
                    this._intro3.visible = true;
                    _Common2.default.audio.playSound("sfx_tv_help_static_00");
                },
                onStartScope: this
            }));

            // next button
            this._nextButton.scale = new PIXI.Point();
            TweenMax.to(this._nextButton.scale, 0.34, {
                delay: _Common2.default.isFirstTime ? 2 : 0.2,
                x: 1.0,
                y: 1.0,
                ease: Back.easeOut,
                easeParams: [2],
                onStart: function onStart() {
                    this._nextButton.visible = true;
                },
                onStartScope: this
            });
        }
    }, {
        key: "animateOut",
        value: function animateOut() {}
    }, {
        key: "resize",
        value: function resize() {
            this.y = (p3.View.height - _Common2.default.STAGE_HEIGHT) * 0.5;

            this._nextButton.x = p3.View.width - 100;
            this._nextButton.y = (_Common2.default.STAGE_HEIGHT + p3.View.height) * 0.5 - 100;
        }
    }, {
        key: "update",
        value: function update() {}

        /**
         * @param {p3.Button} button
         */

    }, {
        key: "onNextButtonClick",
        value: function onNextButtonClick(button) {
            this.signals.next.dispatch(this);
        }
    }]);

    return IntroScene;
}(p3.Scene);

exports.default = IntroScene;

},{"./Common":11}],19:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }(); /**
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      *  Main
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      *
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      *  Created by Legman on 19/9/2015.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      *
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      */

var _Application = require("./Application");

var _Application2 = _interopRequireDefault(_Application);

var _AudioManager = require("./AudioManager");

var _AudioManager2 = _interopRequireDefault(_AudioManager);

var _BoomerangPreloaderScene = require("./BoomerangPreloaderScene");

var _BoomerangPreloaderScene2 = _interopRequireDefault(_BoomerangPreloaderScene);

var _CNPreloaderScene = require("./CNPreloaderScene");

var _CNPreloaderScene2 = _interopRequireDefault(_CNPreloaderScene);

var _Common = require("./Common");

var _Common2 = _interopRequireDefault(_Common);

var _Input = require("./Input");

var _Input2 = _interopRequireDefault(_Input);

var _ismobilejs = require("ismobilejs");

var _ismobilejs2 = _interopRequireDefault(_ismobilejs);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * @class
 */
var Main = function () {
    /**
     * @param {number} width
     * @param {number} height
     */
    function Main(width, height) {
        _classCallCheck(this, Main);

        /**
         * @member {!number}
         * @private
         */
        this._width = width;

        /**
         * @member {!number}
         * @private
         */
        this._height = height;

        /**
         * @member {PreloaderScene}
         * @private
         */
        this._preloader = null;

        /**
         * @member {Application}
         * @private
         */
        this._game = null;
    }

    _createClass(Main, [{
        key: "init",
        value: function init() {
            _Common2.default.assets = p3.AssetManager.instance;
            _Common2.default.audio = p3.Button.audio = new _AudioManager2.default();
            _Common2.default.language = language;

            var params = new p3.ViewParams();
            params.holderId = "game";
            params.width = this._width;
            params.height = this._height;
            params.portrait = true;
            params.aspectRatioFillHeight = false;
            params.rotateImageUrl = "./assets/images/localisation/rotate_" + language + ".jpg";
            params.rotateImageColor = "#000000";

            PIXI.settings.RETINA_PREFIX = /\_(?=[^_]*$)(.+)x/;

            p3.Device.init(window["bowser"]);

            TweenMax.defaultOverwrite = "none";
            TweenMax.ticker.fps(60);

            var view = new p3.View(params);
            view.signals.ready.addOnce(function (canvas) {
                var options = {};
                options.view = canvas;
                options.transparent = false;
                options.antialias = false;
                options.preserveDrawingBuffer = false;
                options.resolution = 1.0;

                var stage = new PIXI.Container();
                _Common2.default.stage = stage;

                var input = new _Input2.default();
                input.init(stage, canvas);
                _Common2.default.input = input;

                if (p3.Device.isCocoonJS) {
                    stage.scale.x = window.innerHeight / params.height;
                    stage.scale.y = window.innerHeight / params.height;
                }

                var renderer = !p3.Device.isCocoonJS ? PIXI.autoDetectRenderer(this._width, this._height, options) : new PIXI.WebGLRenderer(window.innerWidth, window.innerHeight, options);
                renderer.backgroundColor = 0x0;
                _Common2.default.renderer = renderer;
                _Common2.default.isWebGL = renderer instanceof PIXI.WebGLRenderer;

                var scene = new p3.SceneManager(renderer);
                scene.updateAll = true;
                _Common2.default.scene = scene;
                _Common2.default.stage.addChild(scene.view);

                PIXI.ticker.shared.add(function (deltaTime) {
                    window.deltaTime = deltaTime / PIXI.settings.TARGET_FPMS / 1000;

                    scene.update();
                    renderer.render(_Common2.default.stage);
                }, this);

                window.delay = function (callback, delay, scope) {
                    return TweenMax.delayedCall(delay, callback, [], scope);
                };
                window.translate = function (str) {
                    var s = _Common2.default.config.strings[str];
                    s = s && s[_Common2.default.language];
                    return typeof s !== "undefined" ? s : str;
                };

                this.loadPreloader();
            }, this);
            view.signals.resize.add(this.onCanvasResize, this);
            _Common2.default.view = view;
        }
    }, {
        key: "loadPreloader",
        value: function loadPreloader() {
            var files = [{ name: "buttons_1x", url: "images/" + "buttons_1x" + ".json" }, { name: "strings", url: "data/" + "strings" + ".json" }, { name: "cloudy_bold_60", url: "fonts/" + "cloudy_bold_60" + ".xml" }, { name: "cloudy_bold_100", url: "fonts/" + "cloudy_bold_100" + ".xml" }, { name: "cloudy_8bit2_60", url: "fonts/" + "cloudy_8bit2_60" + ".xml" }];

            if (boomerang) {
                files = files.concat([{ name: "preloader_1x", url: "images/" + "preloader_1x" + ".json" }]);
            } else {
                files = files.concat([{ name: "cn_preloader", url: "images/" + "cn_preloader" + ".jpg" }, { name: "cn_preloader_1x", url: "images/" + "cn_preloader_1x" + ".json" }]);
            }

            var sounds = [];
            if (files.length) {
                _Common2.default.assets.addFiles(files, "assets/");
                _Common2.default.assets.signals.complete.addOnce(function () {
                    this.createConfig();
                    this.loadAssets();
                }, this);
                _Common2.default.assets.load();
            } else {
                this.loadAssets();
            }
        }
    }, {
        key: "loadAssets",
        value: function loadAssets() {
            var files = [{ name: "bg_end", url: "images/" + "bg_end" + ".jpg" }, { name: "bg_game", url: "images/" + "bg_game" + ".jpg" }, { name: "bg_intro", url: "images/" + "bg_intro" + ".jpg" }, { name: "bg_splash", url: "images/" + "bg_splash" + ".jpg" }, { name: "game_1x", url: "images/" + "game_1x" + ".json" }, { name: "gradients_1x", url: "images/" + "gradients_1x" + ".json" }, { name: "intro_1x", url: "images/" + "intro_1x" + ".json" }, { name: "particles_1x", url: "images/" + "particles_1x" + ".json" }, { name: "pause_1x", url: "images/" + "pause_1x" + ".json" }, { name: "results_1x", url: "images/" + "results_1x" + ".json" }, { name: "tiles_1x", url: "images/" + "tiles_1x" + ".json" }, { name: "ui_1x", url: "images/" + "ui_1x" + ".json" }, { name: "title", url: "images/localisation/" + "title_" + language + ".png" }, { name: "steve", url: "images/" + "steve" + ".json" }, { name: "replicator_001", url: "particles/" + "replicator_001" + ".json" }, { name: "end_game_confetti", url: "particles/" + "end_game_confetti" + ".json" }, { name: "best", url: "particles/" + "best" + ".json" }];
            var sounds = ["music_ingame_00", "music_mainmenu_screen_00", "music_pause_screen_00", "music_score_screen_00"];
            var sprite = {
                "silence": [0, 2000, true],
                "sfx_ambience_lab_00": [3000, 8192.086167800455],
                "sfx_arm_left_00": [13000, 991.3378684807252],
                "sfx_arm_right_00": [15000, 991.3378684807252],
                "sfx_arm_up_00": [17000, 412.22222222222274],
                "sfx_btn_home_00": [19000, 440.1587301587284],
                "sfx_btn_press_00": [21000, 385.192743764172],
                "sfx_clone_zap_00": [23000, 394.263038548754],
                "sfx_clone_zap_01": [25000, 701.3832199546499],
                "sfx_game_over_00": [27000, 2304.013605442176],
                "sfx_game_play_cpu_intro_00": [31000, 7288.526077097508],
                "sfx_new_highscore_01": [40000, 2714.96598639456],
                "sfx_results_reveal_00": [44000, 2196.5079365079346],
                "sfx_results_reveal_01": [48000, 1303.3333333333346],
                "sfx_results_reveal_02": [51000, 1974.1043083900252],
                "sfx_results_reveal_03": [54000, 1376.1678004535156],
                "sfx_results_reveal_04": [57000, 3753.922902494331],
                "sfx_results_reveal_05": [62000, 2331.156462585028],
                "sfx_steve_00": [66000, 1162.8344671201774],
                "sfx_steve_01": [69000, 866.0317460317515],
                "sfx_steve_can_00": [71000, 566.1904761904708],
                "sfx_steve_fall_scream_00": [73000, 346.87074829932385],
                "sfx_steve_fall_scream_01": [75000, 368.86621315193224],
                "sfx_steve_fall_scream_02": [77000, 433.0385487528332],
                "sfx_steve_fall_scream_03": [79000, 322.1088435374213],
                "sfx_steve_gummybears_00": [81000, 619.2063492063511],
                "sfx_steve_land_normal_00": [83000, 264.1950113378755],
                "sfx_steve_land_normal_01": [85000, 195.66893424035925],
                "sfx_steve_land_normal_02": [87000, 270.8390022675786],
                "sfx_steve_land_normal_03": [89000, 202.04081632653015],
                "sfx_steve_land_normal_04": [91000, 186.43990929705012],
                "sfx_steve_land_perfect_03": [93000, 649.7052154195018],
                "sfx_steve_ouch_00": [95000, 382.6077097505731],
                "sfx_tv_help_static_00": [97000, 216.7120181405835]
            };
            if (files.length) {
                this._preloader = boomerang ? new _BoomerangPreloaderScene2.default() : new _CNPreloaderScene2.default();
                _Common2.default.scene.add(this._preloader);

                _Common2.default.assets.addFiles(files, "assets/");
                _Common2.default.assets.signals.progress.add(this.onLoadingProgress, this);
                _Common2.default.assets.signals.complete.addOnce(this.onLoadingCompleted, this);
                _Common2.default.assets.load();

                var extensions = _ismobilejs2.default.android.device ? [".ogg"] : [".m4a", ".mp3", ".ogg"];
                console.log(extensions);
                _Common2.default.audio.addSoundSprite("sprite", sprite, extensions, "assets/audio/");
                _Common2.default.audio.addSounds(sounds, extensions, "assets/audio/");
            } else {
                this.startGame();
            }
        }
    }, {
        key: "createConfig",
        value: function createConfig() {
            var assets = _Common2.default.assets;

            var config = {};
            config.strings = assets.getJSON("strings");
            _Common2.default.config = config;
            console.log(config);
        }

        /**
         * @param [t=0]
         */

    }, {
        key: "startGame",
        value: function startGame() {
            var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;

            delay(function () {
                this._game = new _Application2.default();
                this._game.init();
            }, t, this);
        }

        /**
         * @param {Event} event
         */

    }, {
        key: "onLoadingProgress",
        value: function onLoadingProgress(event) {
            this._preloader.loaded = event.progress / 100.0;
        }
    }, {
        key: "onLoadingCompleted",
        value: function onLoadingCompleted() {
            _Common2.default.assets.signals.progress.removeAll();
            _Common2.default.assets.signals.complete.removeAll();

            this._preloader.loaded = 1;

            if (_ismobilejs2.default.any) {
                this._preloader.signals.next.add(function () {
                    this.startGame(0);
                }, this);
            } else {
                this.startGame(1);
            }
        }

        /**
         * @param {boolean} correct
         */

    }, {
        key: "onCanvasResize",
        value: function onCanvasResize(correct) {
            if (correct) {
                _Common2.default.renderer.resize(p3.View.width, p3.View.height);
                if (_Common2.default.scene) {
                    _Common2.default.scene.resize();
                }
            }
        }
    }]);

    return Main;
}();

exports.default = Main;

},{"./Application":4,"./AudioManager":6,"./BoomerangPreloaderScene":9,"./CNPreloaderScene":10,"./Common":11,"./Input":17,"ismobilejs":2}],20:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _Common = require("./Common");

var _Common2 = _interopRequireDefault(_Common);

var _GummyBear = require("./GummyBear");

var _GummyBear2 = _interopRequireDefault(_GummyBear);

var _PhysicsActor2 = require("./PhysicsActor");

var _PhysicsActor3 = _interopRequireDefault(_PhysicsActor2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /**
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *  PhysicsActor
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *  Created by Legman on 22/02/2017.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */

/**
 * @class
 */
var Monkey = function (_PhysicsActor) {
    _inherits(Monkey, _PhysicsActor);

    function Monkey() {
        _classCallCheck(this, Monkey);

        var _this = _possibleConstructorReturn(this, (Monkey.__proto__ || Object.getPrototypeOf(Monkey)).call(this));

        var assets = _Common2.default.assets;

        /**
         * @member {number}
         */
        _this.towerY = 0;

        /**
         * @member {boolean}
         */
        _this.onTop = true;

        _this.view = new PIXI.spine.Spine(assets.getSpineData("steve"));
        _this.view.position.set(10, 70);
        _this.view.scale.set(0.5, 0.5);
        _this.view.skeleton.setToSetupPose();
        _this.view.skeleton.setSkin(null);
        _this.view.autoUpdate = false;
        _this.view.state.addListener({ complete: _this.onAnimationComplete.bind(_this) });
        _this.view.update(0);
        _this.addChild(_this.view);

        /**
         * @member {Array.<string>}
         * @private
         */
        _this._idleAnimationNames = ["idle_bored", "idle_bum", "idle_gorilla", "idle_jig", "idle_look_down", "idle_look_left", "idle_look_right", "idle_look_up", "idle_nose", "idle_wink"];

        /**
         * @member {Array.<string>}
         * @private
         */
        _this._topAnimationNames = ["top_idle_look", "top_idle_scratch", "top_idle_smile", "top_idle_wave"];

        /**
         * @member {Array.<string>}
         * @private
         */
        _this._hitAnimationNames = ["hit_001", "hit_002", "hit_003", "hit_004", "hit_005", "hit_006", "hit_007", "hit_008", "hit_009", "hit_010"];

        /**
         * @member {Array.<string>}
         * @private
         */
        _this._spawnAnimationNames = ["top_spawn_001", "top_spawn_002"];

        /**
         * @member {Array}
         * @private
         */
        _this._landAnimationNames = ["top_land"];
        return _this;
    }

    _createClass(Monkey, [{
        key: "init",
        value: function init() {
            _get(Monkey.prototype.__proto__ || Object.getPrototypeOf(Monkey.prototype), "init", this).call(this);

            this.playIdleState(this.onTop);
        }
    }, {
        key: "update",
        value: function update() {
            _get(Monkey.prototype.__proto__ || Object.getPrototypeOf(Monkey.prototype), "update", this).call(this);

            // view is visible when in the viewport
            var y = this.y - _Common2.default.camera.position.y;
            var height = p3.View.height * 1.2;
            this.view.visible = y > (_Common2.default.STAGE_HEIGHT - height) * 0.5 && y < (_Common2.default.STAGE_HEIGHT + height) * 0.5;

            // only update the animation when the monkeys are visible
            if (this.view.visible) {
                this.spine.update(deltaTime);
            }
        }

        /**
         * @returns {p2.Body}
         */

    }, {
        key: "createBody",
        value: function createBody() {
            var body = new p2.Body({ mass: 1.0 });
            body.type = p2.Body.DYNAMIC;
            body.allowSleep = true;
            body.sleepSpeedLimit = 4.0;
            body.parent = this;

            var shape = new p2.Box({ width: 134, height: 142 });
            shape.collisionGroup = _PhysicsActor3.default.DEFAULT;
            shape.collisionMask = _PhysicsActor3.default.DEFAULT | _PhysicsActor3.default.GUMMY_BEAR;
            shape.material = _PhysicsActor3.default.MATERIAL_DEFAULT;

            body.addShape(shape);
            return body;
        }

        /**
         * @param {boolean} [top]
         * @returns {string}
         */

    }, {
        key: "playIdleState",
        value: function playIdleState(top) {
            var arr = top ? this._topAnimationNames : this._idleAnimationNames;
            var animationName = arr[Math.floor(Math.random() * arr.length)];
            this.spine.state.setAnimation(0, animationName, false);
            return animationName;
        }

        /**
         * @param {boolean} [top]
         * @returns {string}
         */

    }, {
        key: "playHitState",
        value: function playHitState(top) {
            var arr = top ? this._landAnimationNames : this._hitAnimationNames;
            var animationName = arr[Math.floor(Math.random() * arr.length)];
            this.spine.state.setAnimation(0, animationName, false);
            return animationName;
        }

        /**
         * @returns {string}
         */

    }, {
        key: "playSpawnState",
        value: function playSpawnState() {
            var animationName = this._spawnAnimationNames[Math.floor(Math.random() * this._spawnAnimationNames.length)];
            this.spine.state.setAnimation(0, animationName, true);
            return animationName;
        }
    }, {
        key: "playOuchSFX",
        value: function playOuchSFX() {
            if (this.onTop) {
                var velocity = new p3.Vector2(this.body.velocity[0], this.body.velocity[1]);
                if (velocity.lengthSq > 100) {
                    _Common2.default.audio.playSound("sfx_steve_ouch_00");
                }
            } else {
                if (Math.random() < 0.25) {
                    delay(function () {
                        _Common2.default.audio.playSound("sfx_steve_ouch_00");
                    }, 0.1 + Math.random() * 0.2, this);
                }
            }
        }

        /**
         * @param {p2.Body} [body]
         */

    }, {
        key: "onBeginContact",
        value: function onBeginContact(body) {
            if (body.parent instanceof _GummyBear2.default) return;

            _get(Monkey.prototype.__proto__ || Object.getPrototypeOf(Monkey.prototype), "onBeginContact", this).call(this, body);

            this.playHitState(this.onTop);
            this.playOuchSFX();
        }

        /**
         * @param {p2.Body} [body]
         */

    }, {
        key: "onEndContact",
        value: function onEndContact(body) {}

        /**
         * @param {!number} trackIndex
         * @param {!number} loopCount
         */

    }, {
        key: "onAnimationComplete",
        value: function onAnimationComplete(trackIndex, loopCount) {
            var animationName = this.spine.state.tracks[0].animation.name;

            if (this._idleAnimationNames.indexOf(animationName) > -1 || this._topAnimationNames.indexOf(animationName) > -1 || this._hitAnimationNames.indexOf(animationName) > -1 || this._landAnimationNames.indexOf(animationName) > -1) {
                this._hit = false;

                this.playIdleState(this.onTop);
            }
        }
    }]);

    return Monkey;
}(_PhysicsActor3.default);

exports.default = Monkey;

},{"./Common":11,"./GummyBear":14,"./PhysicsActor":22}],21:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _Common = require("./Common");

var _Common2 = _interopRequireDefault(_Common);

var _ScanlinesFilter = require("./ScanlinesFilter");

var _ScanlinesFilter2 = _interopRequireDefault(_ScanlinesFilter);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /**
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *  PauseScene
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *  Created by Legman on 24/02/2017.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */

/**
 * @class
 */
var PauseScene = function (_p3$Scene) {
    _inherits(PauseScene, _p3$Scene);

    function PauseScene() {
        _classCallCheck(this, PauseScene);

        /**
         * @member {signals.Signal}
         */
        var _this = _possibleConstructorReturn(this, (PauseScene.__proto__ || Object.getPrototypeOf(PauseScene)).call(this));

        _this.signals.help = new signals.Signal();

        /**
         * @member {PIXI.Sprite}
         * @private
         */
        _this._panel = null;

        /**
         * @member {p3.MovieClip}
         * @private
         */
        _this._steve = null;

        /**
         * @type {p3.MovieClip}
         * @private
         */
        _this._steve2 = null;

        /**
         * @member {PIXI.Sprite}
         * @private
         */
        _this._hand = null;

        /**
         * @member {p3.Button}
         * @private
         */
        _this._homeButton = null;

        /**
         * @member {p3.Button}
         * @private
         */
        _this._muteButton = null;

        /**
         * @member {p3.Button}
         * @private
         */
        _this._helpButton = null;

        /**
         * @member {p3.Button}
         * @private
         */
        _this._resumeButton = null;

        /**
         * @member {TimelineMax}
         * @private
         */
        _this._animation = null;

        /**
         * @member {Audio}
         * @private
         */
        _this._introSFX = null;
        return _this;
    }

    _createClass(PauseScene, [{
        key: "init",
        value: function init() {
            _get(PauseScene.prototype.__proto__ || Object.getPrototypeOf(PauseScene.prototype), "init", this).call(this);

            var assets = _Common2.default.assets;

            var bg = new PIXI.Sprite(assets.getTexture("paused_overlay"));
            bg.width = p3.View.width;
            this.addChild(bg);

            this._panel = new PIXI.Sprite(assets.getTexture("paused_panel"));
            this._panel.x = p3.View.width * 0.5 + 6;
            this._panel.y = 60;
            this._panel.anchor.x = 0.5;
            this._panel.visible = false;
            this.addChild(this._panel);

            this._panel.stem = new PIXI.Sprite(assets.getTexture("paused_panel_stem"));
            this._panel.stem.anchor.x = 0.5;
            this._panel.addChild(this._panel.stem);

            this._panel.image = new PIXI.Sprite(assets.getTexture("instructions_screen"));
            this._panel.image.x = -14;
            this._panel.image.y = 862;
            this._panel.image.anchor = new PIXI.Point(0.5, 0.5);
            this._panel.image.visible = false;
            this._panel.addChild(this._panel.image);

            var sequence = new p3.MovieClipSequence();
            sequence.addTextures([assets.getTexture("instructions_monkey_fall"), assets.getTexture("instructions_monkey_land")]);

            this._steve = new p3.MovieClip(sequence);
            this._steve.y = -40;
            this._steve.anchor = new PIXI.Point(0.5, 0.5);
            this._steve.visible = false;
            this._panel.image.addChild(this._steve);

            this._steve2 = new p3.MovieClip(sequence);
            this._steve2.y = this._steve.y;
            this._steve2.anchor = new PIXI.Point(0.5, 0.5);
            this._steve2.visible = false;
            this._panel.image.addChild(this._steve2);

            this._hand = new PIXI.Sprite(assets.getTexture("tutorial_hand"));
            this._hand.x = 60;
            this._hand.y = 40;
            this._hand.anchor = new PIXI.Point(0.5, 0.5);
            this._panel.image.addChild(this._hand);

            /*
            this._titleLabel = new PIXI.extras.BitmapText("PAUSED...", {font: "100px Cloudy Bold Large", align: "center"});
            this._titleLabel.x = 20;
            this._titleLabel.y = 20;
            this._titleLabel.pivot.x = this._titleLabel.textWidth * 0.5;
            this._titleLabel.pivot.y = this._titleLabel.textHeight * 0.5;
            this._titleLabel.tint = 0xEF041F;
            this._panel.image.addChild(this._titleLabel);
            */

            var filter = new _ScanlinesFilter2.default(this._panel.image);
            this._panel.image.filters = [filter];

            var states = new p3.ButtonStates();
            states.normal = assets.getTexture("btn_small_off");
            states.icon = assets.getTexture("icon_home_off");

            this._homeButton = new p3.Button(states);
            this._homeButton.visible = false;
            this._homeButton.overSoundName = "sfx_btn_press_00";
            this._homeButton.clickSoundName = "sfx_btn_home_00";
            this._homeButton.signals.click.add(this.onHomeButtonClick, this);
            this.addChild(this._homeButton);

            states = new p3.ButtonStates();
            states.normal = assets.getTexture("btn_small_off");
            states.icon = assets.getTexture("icon_sound_off");
            states.iconAlt = assets.getTexture("icon_mute_off");

            this._muteButton = new p3.MuteButton(states);
            this._muteButton.visible = false;
            this._muteButton.overSoundName = "sfx_btn_press_00";
            this._muteButton.clickSoundName = "sfx_btn_home_00";
            this.addChild(this._muteButton);

            states = new p3.ButtonStates();
            states.normal = assets.getTexture("btn_small_off");
            states.icon = assets.getTexture("icon_help_off");

            this._helpButton = new p3.Button(states);
            this._helpButton.visible = false;
            this._helpButton.overSoundName = "sfx_btn_press_00";
            this._helpButton.clickSoundName = "sfx_btn_home_00";
            this._helpButton.signals.click.add(this.onHelpButtonClick, this);
            this.addChild(this._helpButton);

            states = new p3.ButtonStates();
            states.normal = assets.getTexture("btn_small_off");
            states.icon = assets.getTexture("icon_play_off");

            this._resumeButton = new p3.Button(states);
            this._resumeButton.visible = false;
            this._resumeButton.overSoundName = "sfx_btn_press_00";
            this._resumeButton.clickSoundName = "sfx_btn_home_00";
            this._resumeButton.signals.click.add(this.onResumeButtonClick, this);
            this.addChild(this._resumeButton);

            this._introSFX = _Common2.default.audio.playSound("sfx_game_play_cpu_intro_00");
        }
    }, {
        key: "destroy",
        value: function destroy() {
            this._animation.kill();

            this._introSFX.stop();

            _get(PauseScene.prototype.__proto__ || Object.getPrototypeOf(PauseScene.prototype), "destroy", this).call(this);
        }
    }, {
        key: "appear",
        value: function appear() {
            _get(PauseScene.prototype.__proto__ || Object.getPrototypeOf(PauseScene.prototype), "appear", this).call(this);
        }

        /**
         * @param {function} [callback]
         * @param {*} [scope]
         */

    }, {
        key: "animateIn",
        value: function animateIn(callback, scope) {
            // panel
            var to = this._panel.y;
            this._panel.y = -this._panel.height;
            TweenMax.to(this._panel, 0.4, {
                delay: 0.1,
                y: to,
                ease: Back.easeOut,
                easeParams: [0.8],
                onStart: function onStart() {
                    this._panel.visible = true;
                },
                onStartScope: this,
                onComplete: function onComplete() {
                    // panel screen
                    this._panel.image.scale.y = 0;
                    TweenMax.to(this._panel.image.scale, 0.14, {
                        y: 1,
                        ease: Power2.easeInOut,
                        onStart: function onStart() {
                            this._panel.image.visible = true;
                        },
                        onStartScope: this
                    });
                    this._panel.image.alpha = 0;
                    TweenMax.to(this._panel.image, 0.1, {
                        alpha: 1,
                        ease: Power1.easeInOut
                    });
                },
                onCompleteScope: this
            });

            // home button
            this._homeButton.scale = new PIXI.Point();
            TweenMax.to(this._homeButton.scale, 0.34, {
                delay: 0.2,
                x: 1.0,
                y: 1.0,
                ease: Back.easeOut,
                easeParams: [2],
                onStart: function onStart() {
                    this._homeButton.visible = true;
                },
                onStartScope: this
            });

            // mute button
            this._muteButton.scale = new PIXI.Point();
            TweenMax.to(this._muteButton.scale, 0.34, {
                delay: 0.2 + 0.06,
                x: 1.0,
                y: 1.0,
                ease: Back.easeOut,
                easeParams: [2],
                onStart: function onStart() {
                    this._muteButton.visible = true;
                },
                onStartScope: this
            });

            // help button
            /*
            this._helpButton.scale = new PIXI.Point();
            TweenMax.to(this._helpButton.scale, 0.34, {
                delay: 0.1 + 0.06 * 2,
                x: 1.0,
                y: 1.0,
                ease: Back.easeOut,
                easeParams: [2],
                onStart: function() {
                    this._helpButton.visible = true;
                },
                onStartScope: this
            });
            */

            // resume button
            this._resumeButton.scale = new PIXI.Point();
            TweenMax.to(this._resumeButton.scale, 0.34, {
                delay: 0.2 + 0.06 * 2,
                x: 1.0,
                y: 1.0,
                ease: Back.easeOut,
                easeParams: [2],
                onStart: function onStart() {
                    this._resumeButton.visible = true;
                },
                onStartScope: this
            });

            this._animation = new TimelineMax({ delay: 1, repeat: -1 });

            // hand
            this._animation.append(TweenMax.to(this._hand.scale, 0.2, {
                delay: 0.2,
                x: 0.9,
                y: 0.9,
                ease: Back.easeOut,
                yoyo: true,
                repeat: 1,
                onStart: function onStart() {
                    this._hand.visible = true;
                },
                onStartScope: this
            }));
            this._animation.append(TweenMax.to(this._hand, 0.2, {
                delay: 0.2,
                alpha: 0,
                ease: Power1.easeInOut
            }));

            // steve
            this._steve.scale = new PIXI.Point();
            this._animation.append(TweenMax.to(this._steve.scale, 0.34, {
                x: 1,
                y: 1,
                ease: Back.easeOut,
                onStart: function onStart() {
                    this._steve.visible = true;
                    this._steve.gotoAndStop(0);
                },
                onStartScope: this
            }));

            to = 124;
            var distance = to - this._steve.y;
            var speed = 460;
            this._animation.append(TweenMax.to(this._steve, distance / speed, {
                y: to,
                ease: Power1.easeIn,
                onComplete: function onComplete() {
                    this._steve.gotoAndStop(1);
                },
                onCompleteScope: this
            }));

            // steve2
            this._steve2.scale = new PIXI.Point();
            this._animation.append(TweenMax.to(this._steve2.scale, 0.34, {
                delay: 0.8,
                x: 1,
                y: 1,
                ease: Back.easeOut,
                onStart: function onStart() {
                    this._steve2.visible = true;
                    this._steve2.gotoAndStop(0);
                },
                onStartScope: this
            }));

            to = 48;
            distance = to - this._steve2.y;
            speed = 460;
            this._animation.append(TweenMax.to(this._steve2, distance / speed, {
                y: to,
                ease: Power1.easeIn,
                onComplete: function onComplete() {
                    this._steve2.gotoAndStop(1);
                },
                onCompleteScope: this
            }));

            this._animation.append(TweenMax.delayedCall(1, function () {}));
        }

        /**
         * @param {function} [callback]
         * @param {*} [scope]
         */

    }, {
        key: "animateOut",
        value: function animateOut(callback, scope) {}
    }, {
        key: "resize",
        value: function resize() {
            this.y = (p3.View.height - _Common2.default.STAGE_HEIGHT) * 0.5;

            this._homeButton.x = 100;
            this._homeButton.y = (_Common2.default.STAGE_HEIGHT - p3.View.height) * 0.5 + 100;

            this._muteButton.x = p3.View.width - 100;
            this._muteButton.y = (_Common2.default.STAGE_HEIGHT - p3.View.height) * 0.5 + 100;

            this._resumeButton.x = p3.View.width - 100;
            this._resumeButton.y = (_Common2.default.STAGE_HEIGHT + p3.View.height) * 0.5 - 100;
        }
    }, {
        key: "update",
        value: function update() {
            var filter = this._panel.image.filters[0];
            filter.time -= deltaTime * 4;
        }

        /**
         * @param {p3.Button} button
         */

    }, {
        key: "onHomeButtonClick",
        value: function onHomeButtonClick(button) {
            this.signals.home.dispatch(this);
        }

        /**
         * @param {p3.Button} button
         */

    }, {
        key: "onHelpButtonClick",
        value: function onHelpButtonClick(button) {
            this.signals.help.dispatch(this);
        }

        /**
         * @param {p3.Button} button
         */

    }, {
        key: "onResumeButtonClick",
        value: function onResumeButtonClick(button) {
            this.signals.next.dispatch(this);
        }
    }]);

    return PauseScene;
}(p3.Scene);

exports.default = PauseScene;

},{"./Common":11,"./ScanlinesFilter":24}],22:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _Actor2 = require("./Actor");

var _Actor3 = _interopRequireDefault(_Actor2);

var _Common = require("./Common");

var _Common2 = _interopRequireDefault(_Common);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /**
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *  PhysicsActor
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *  Created by Legman on 22/02/2017.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */

/**
 * @class
 */
var PhysicsActor = function (_Actor) {
    _inherits(PhysicsActor, _Actor);

    /**
     * @param {PIXI.Texture} [texture]
     */
    function PhysicsActor(texture) {
        _classCallCheck(this, PhysicsActor);

        /**
         * @member {boolean}
         */
        var _this = _possibleConstructorReturn(this, (PhysicsActor.__proto__ || Object.getPrototypeOf(PhysicsActor)).call(this, texture));

        _this.syncToBody = true;

        /**
         * @member {boolean}
         * @private
         */
        _this._hit = false;

        _this.body = _this.createBody();
        if (_this.body) {
            _this.body.parent = _this;
            _this.body.updateMassProperties();
            _Common2.default.world.addBody(_this.body);
        }
        return _this;
    }

    _createClass(PhysicsActor, [{
        key: "init",
        value: function init() {
            _get(PhysicsActor.prototype.__proto__ || Object.getPrototypeOf(PhysicsActor.prototype), "init", this).call(this);

            if (this.body) {
                this.body.position = [this.x, this.y];
                this.body.angle = this.rotation;
            }
        }

        /**
         * @param {boolean} [destroyChildren]
         */

    }, {
        key: "destroy",
        value: function destroy(destroyChildren) {
            this.body && _Common2.default.world.removeBody(this.body);

            _get(PhysicsActor.prototype.__proto__ || Object.getPrototypeOf(PhysicsActor.prototype), "destroy", this).call(this);
        }

        /**
         * @returns {p2.Body}
         */

    }, {
        key: "createBody",
        value: function createBody() {
            return null;
        }
    }, {
        key: "update",
        value: function update() {
            _get(PhysicsActor.prototype.__proto__ || Object.getPrototypeOf(PhysicsActor.prototype), "update", this).call(this);

            this.body && this.synchronizePhysics();
        }
    }, {
        key: "synchronizePhysics",
        value: function synchronizePhysics() {
            if (this.syncToBody) {
                this.x = this.body.position[0];
                this.y = this.body.position[1];
                this.rotation = this.body.angle;
            } else {
                this.body.position[0] = this.x;
                this.body.position[1] = this.y;
                this.body.angle = this.rotation;
            }
        }

        /**
         * @param {p2.Body} [body]
         */

    }, {
        key: "onBeginContact",
        value: function onBeginContact(body) {
            this._hit = true;
        }

        /**
         * @param {p2.Body} [body]
         */

    }, {
        key: "onEndContact",
        value: function onEndContact(body) {
            this._hit = false;
        }

        /**
         * @returns {boolean}
         */

    }, {
        key: "hit",
        get: function get() {
            return this._hit;
        }
    }]);

    return PhysicsActor;
}(_Actor3.default);

/**
 * @static
 * @const
 * @type {number}
 */


exports.default = PhysicsActor;
PhysicsActor.DEFAULT = Math.pow(2, 0);

/**
 * @static
 * @const
 * @type {number}
 */
PhysicsActor.GUMMY_BEAR = Math.pow(2, 1);

/**
 * @static
 * @const
 * @type {p2.Material}
 */
PhysicsActor.MATERIAL_DEFAULT = new p2.Material();

/**
 * @static
 * @const
 * @type {p2.Material}
 */
PhysicsActor.MATERIAL_GUMMY_BEAR = new p2.Material();

},{"./Actor":3,"./Common":11}],23:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
        value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _Actor2 = require("./Actor");

var _Actor3 = _interopRequireDefault(_Actor2);

var _Audio = require("./Audio");

var _Audio2 = _interopRequireDefault(_Audio);

var _AudioParams = require("./AudioParams");

var _AudioParams2 = _interopRequireDefault(_AudioParams);

var _Common = require("./Common");

var _Common2 = _interopRequireDefault(_Common);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /**
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *  Replicator
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *  Created by Legman on 22/02/2017.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */

/**
 * @class
 */
var Replicator = function (_Actor) {
        _inherits(Replicator, _Actor);

        function Replicator() {
                _classCallCheck(this, Replicator);

                var assets = _Common2.default.assets;

                /**
                 * @member {number}
                 */
                var _this = _possibleConstructorReturn(this, (Replicator.__proto__ || Object.getPrototypeOf(Replicator)).call(this, assets.getTexture("replicator_support")));

                _this.moveSpeed = 0;

                /**
                 * @member {{min: number, max: number}}
                 */
                _this.moveSpeedRange = { min: 540, max: 540 };

                /**
                 * @member {{lower: number, upper: number}}
                 */
                _this.moveSpeedLimit = { lower: 440, upper: 1200 };

                /**
                 * @member {{lower: number, upper: number}}
                 */
                _this.moveSpeedMulti = { lower: 0.92, upper: 1.24 };

                /**
                 * @member {number}
                 */
                _this.moveRange = p3.View.width * 0.32;

                /**
                 * @member {boolean}
                 */
                _this.moving = true;

                /**
                 * @member {number}
                 * @private
                 */
                _this.direction = Math.random() < 0.5 ? 1 : -1;

                /**
                 * @member {PIXI.Point}
                 */
                _this.startPos = new PIXI.Point();

                /**
                 * @member {p3.MovieClip}
                 * @private
                 */
                _this._wire = null;

                /**
                 * @member {p3.MovieClip}
                 * @private
                 */
                _this._head = null;

                /**
                 * @member {PIXI.Sprite}
                 * @private
                 */
                _this._beam = null;

                /**
                 * @member {boolean}
                 * @private
                 */
                _this._charged = false;

                /**
                 * @member {Audio}
                 * @private
                 */
                _this._moveSFX = null;

                /**
                 * @member {PIXI.particles.Emitter}
                 * @private
                 */
                _this._emitter = null;
                return _this;
        }

        _createClass(Replicator, [{
                key: "init",
                value: function init() {
                        _get(Replicator.prototype.__proto__ || Object.getPrototypeOf(Replicator.prototype), "init", this).call(this);

                        this.startPos.x = this.x;
                        this.startPos.y = this.y;

                        var assets = _Common2.default.assets;

                        var sequence = new p3.MovieClipSequence();
                        sequence.addTextures([assets.getTexture("replicator_wire_off"), assets.getTexture("replicator_wire_on")]);

                        this._wire = new p3.MovieClip(sequence);
                        this._wire.anchor = new PIXI.Point(0.5, 0.5);
                        this._wire.gotoAndStop(1);
                        this.addChildAt(this._wire, 0);

                        this._glow = new PIXI.Sprite(assets.getTexture("replicator_front_on"));
                        this._glow.anchor = new PIXI.Point(0.5, 0.5);
                        this.addChildAt(this._glow, 0);

                        this._head = new PIXI.Sprite(assets.getTexture("replicator_front_off"));
                        this._head.anchor = new PIXI.Point(0.5, 0.5);
                        this.addChild(this._head);

                        sequence = new p3.MovieClipSequence();
                        sequence.addTextures([assets.getTexture("replicator_lightbulb_off"), assets.getTexture("replicator_lightbulb_on")]);

                        this._head.bulb = new p3.MovieClip(sequence);
                        this._head.bulb.animationSpeed = 1 / 8;
                        this._head.bulb.looping = true;
                        this._head.bulb.anchor = new PIXI.Point(0.5, 0.5);
                        this._head.addChild(this._head.bulb);

                        sequence = new p3.MovieClipSequence();
                        sequence.addTextures([PIXI.Texture.EMPTY, assets.getTexture("replicator_light_001")]);

                        this._head.light1 = new p3.MovieClip(sequence);
                        this._head.light1.animationSpeed = 1 / 24;
                        this._head.light1.looping = true;
                        this._head.light1.anchor = new PIXI.Point(0.5, 0.5);
                        this._head.light1.play();
                        this._head.addChild(this._head.light1);

                        sequence = new p3.MovieClipSequence();
                        sequence.addTextures([PIXI.Texture.EMPTY, assets.getTexture("replicator_light_002")]);

                        this._head.light2 = new p3.MovieClip(sequence);
                        this._head.light2.animationSpeed = 1 / 24;
                        this._head.light2.looping = true;
                        this._head.light2.anchor = new PIXI.Point(0.5, 0.5);
                        this._head.light2.gotoAndPlay(1);
                        this._head.addChild(this._head.light2);

                        this._beam = new PIXI.Sprite(assets.getTexture("replicator_back"));
                        this._beam.y = 374;
                        this._beam.anchor = new PIXI.Point(0.5, 0.5);
                        this._beam.visible = false;
                        this.addChildAt(this._beam, 0);

                        this.charged = true;

                        this.mixUpSpeed();
                        this.playMoveSFX();

                        var holder = new PIXI.Container();
                        this.parent.addChild(holder);

                        var config = assets.getJSON("replicator_001");
                        this._emitter = new PIXI.particles.Emitter(holder, [assets.getTexture("particle_replicator_001")], config);
                        this._emitter.emit = false;
                }

                /**
                 * @param {boolean} [destroyChildren]
                 */

        }, {
                key: "destroy",
                value: function destroy(destroyChildren) {
                        this._moveSFX && this._moveSFX.stop();

                        _get(Replicator.prototype.__proto__ || Object.getPrototypeOf(Replicator.prototype), "destroy", this).call(this, destroyChildren);
                }
        }, {
                key: "update",
                value: function update() {
                        _get(Replicator.prototype.__proto__ || Object.getPrototypeOf(Replicator.prototype), "update", this).call(this);

                        this.moving && (this.x += this.moveSpeed * this.direction * deltaTime);

                        if (Math.abs(this.x - this.startPos.x) > this.moveRange) {
                                this.x = this.startPos.x + this.moveRange * this.direction;
                                this.direction *= -1;

                                this.playMoveSFX();
                        }

                        this.moving && (this._head.y = 216 + p3.Utils.randomInt(1, -1));
                        this._glow.y = this._head.y;

                        this._emitter.updateOwnerPos(this.x, this.y + 360);
                        this._emitter.update(deltaTime);
                }
        }, {
                key: "animate",
                value: function animate() {
                        this._beam.alpha = 1;
                        this._beam.visible = true;
                        this._emitter.emit = true;

                        TweenMax.to(this._beam, 0.34, {
                                delay: 0.44,
                                alpha: 0,
                                ease: Power3.easeInOut,
                                onComplete: function onComplete() {
                                        this._beam.visible = false;
                                        this._emitter.emit = false;
                                },
                                onCompleteScope: this
                        });
                }
        }, {
                key: "mixUpSpeed",
                value: function mixUpSpeed() {
                        this.moveSpeed = p3.Utils.randomInt(this.moveSpeedRange.max, this.moveSpeedRange.min);
                        console.log("movespeed " + this.moveSpeed);
                }
        }, {
                key: "increaseSpeedRange",
                value: function increaseSpeedRange() {
                        this.moveSpeedRange.min = Math.max(this.moveSpeedLimit.lower, this.moveSpeedRange.min * this.moveSpeedMulti.lower);
                        this.moveSpeedRange.max = Math.min(this.moveSpeedLimit.upper, this.moveSpeedRange.max * this.moveSpeedMulti.upper);
                        console.log("speedrange min: " + this.moveSpeedRange.min + " max: " + this.moveSpeedRange.max);
                }
        }, {
                key: "playMoveSFX",
                value: function playMoveSFX() {
                        this.stopMoveSFX();

                        var params = new _AudioParams2.default();
                        params.loop = true;

                        var sounds = void 0;
                        if (this.direction == -1) {
                                sounds = "sfx_arm_left_00";
                        } else if (this.direction == 1) {
                                sounds = "sfx_arm_right_00";
                        }
                        this._moveSFX = _Common2.default.audio.playSound(sounds, params);
                }
        }, {
                key: "playMoveUpSFX",
                value: function playMoveUpSFX() {
                        this.stopMoveSFX();

                        var params = new _AudioParams2.default();
                        params.loop = true;

                        this._moveSFX = _Common2.default.audio.playSound("sfx_arm_left_00", params);
                }
        }, {
                key: "stopMoveSFX",
                value: function stopMoveSFX() {
                        this._moveSFX && this._moveSFX.stop();
                        this._moveSFX = null;
                }

                /**
                 * @returns {boolean}
                 */

        }, {
                key: "charged",
                get: function get() {
                        return this._charged;
                }

                /**
                 * @param {boolean} value
                 */
                ,
                set: function set(value) {
                        this._charged = value;

                        if (this._charged) {
                                this._head.bulb.gotoAndPlay(0);

                                this._glow.alpha = 0;
                                TweenMax.killTweensOf(this._glow);
                                TweenMax.to(this._glow, 0.24, {
                                        alpha: 1,
                                        ease: Power2.easeInOut,
                                        onStart: function onStart() {
                                                this._glow.visible = true;
                                        },
                                        onStartScope: this
                                });
                        } else {
                                this._head.bulb.gotoAndStop(0);
                                this._glow.visible = false;
                        }
                }
        }]);

        return Replicator;
}(_Actor3.default);

exports.default = Replicator;

},{"./Actor":3,"./Audio":5,"./AudioParams":7,"./Common":11}],24:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _glslify = require("glslify");

var _glslify2 = _interopRequireDefault(_glslify);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /**
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *  ScanlinesFilter
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *  Created by Legman on 09/11/2016.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */

/**
 * @class
 */
var ScanlinesFilter = function (_PIXI$Filter) {
    _inherits(ScanlinesFilter, _PIXI$Filter);

    /**
     * @param {PIXI.Sprite} [sprite]
     * @constructor
     */
    function ScanlinesFilter(sprite) {
        _classCallCheck(this, ScanlinesFilter);

        var maskMatrix = new PIXI.Matrix();

        var _this = _possibleConstructorReturn(this, (ScanlinesFilter.__proto__ || Object.getPrototypeOf(ScanlinesFilter)).call(this, null, "precision highp float;\n#define GLSLIFY 1\n\nvarying vec2 vFilterCoord;\nvarying vec2 vTextureCoord;\n\nuniform sampler2D uSampler;\n\nuniform float time;\n\nvoid main() {\n    vec4 color = texture2D(uSampler, vTextureCoord);\n    float a = color.a;\n    color -= abs(sin(vFilterCoord.y * 1000.0 + time * 2.5)) * 0.06;\n    //color -= abs(sin(vFilterCoord.y * 4000.0 + time * 5.0)) * 0.02;\n    color.a = a;\n    gl_FragColor = color;\n}"));

        _this.maskSprite = sprite;
        _this.maskMatrix = maskMatrix;

        _this.uniforms.time = 0;
        _this.uniforms.filterMatrix = maskMatrix;
        return _this;
    }

    _createClass(ScanlinesFilter, [{
        key: "apply",
        value: function apply(filterManager, input, output) {
            this.uniforms.filterMatrix = filterManager.calculateSpriteMatrix(this.maskMatrix, this.maskSprite);
            filterManager.applyFilter(this, input, output);
        }

        /**
         * @returns {number}
         */

    }, {
        key: "time",
        get: function get() {
            return this.uniforms.time;
        }

        /**
         * @param {number} value
         */
        ,
        set: function set(value) {
            this.uniforms.time = value;
        }
    }]);

    return ScanlinesFilter;
}(PIXI.Filter);

exports.default = ScanlinesFilter;

},{"glslify":1}],25:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _Common = require("./Common");

var _Common2 = _interopRequireDefault(_Common);

var _ScanlinesFilter = require("./ScanlinesFilter");

var _ScanlinesFilter2 = _interopRequireDefault(_ScanlinesFilter);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /**
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *  SplashScene
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *  Created by Legman on 24/02/2017.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */

/**
 * @class
 */
var SplashScene = function (_p3$Scene) {
    _inherits(SplashScene, _p3$Scene);

    function SplashScene() {
        _classCallCheck(this, SplashScene);

        /**
         * @member {p3.Button}
         * @private
         */
        var _this = _possibleConstructorReturn(this, (SplashScene.__proto__ || Object.getPrototypeOf(SplashScene)).call(this));

        _this._homeButton = null;

        /**
         * @member {p3.Button}
         * @private
         */
        _this._muteButton = null;

        /**
         * @member {p3.Button}
         * @private
         */
        _this._playButton = null;

        /**
         * @member {PIXI.Sprite}
         * @private
         */
        _this._steve = null;

        /**
         * @member {PIXI.Sprite}
         * @private
         */
        _this._jar = null;

        /**
         * @member {PIXI.Sprite}
         * @private
         */
        _this._base = null;

        /**
         * @member {PIXI.Sprite}
         * @private
         */
        _this._monitorLeft = null;

        /**
         * @member {PIXI.Sprite}
         * @private
         */
        _this._monitorRight = null;

        /**
         * @member {PIXI.Sprite}
         * @private
         */
        _this._title = null;
        return _this;
    }

    _createClass(SplashScene, [{
        key: "init",
        value: function init() {
            _get(SplashScene.prototype.__proto__ || Object.getPrototypeOf(SplashScene.prototype), "init", this).call(this);

            var assets = _Common2.default.assets;

            var bg = new PIXI.Sprite(assets.getTexture("bg_splash"));
            this.addChild(bg);

            this._monitorLeft = new PIXI.Sprite(assets.getTexture("splash_mg_l"));
            this._monitorLeft.x = _Common2.default.STAGE_WIDTH * 0.5;
            this._monitorLeft.y = _Common2.default.STAGE_HEIGHT * 0.5 + 84;
            this._monitorLeft.anchor = new PIXI.Point(0.5, 0.5);
            this._monitorLeft.visible = false;
            this.addChild(this._monitorLeft);

            this._monitorRight = new PIXI.Sprite(assets.getTexture("splash_mg_r"));
            this._monitorRight.x = _Common2.default.STAGE_WIDTH * 0.5;
            this._monitorRight.y = _Common2.default.STAGE_HEIGHT * 0.5 + 84;
            this._monitorRight.anchor = new PIXI.Point(0.5, 0.5);
            this._monitorRight.visible = false;
            this.addChild(this._monitorRight);

            this._base = new PIXI.Sprite(assets.getTexture("splash_mg"));
            this._base.x = p3.View.width * 0.5;
            this._base.y = _Common2.default.STAGE_HEIGHT * 0.5 + 84;
            this._base.anchor = new PIXI.Point(0.5, 0.5);
            this.addChild(this._base);

            this._steve = new PIXI.Sprite(assets.getTexture("splash_monkey"));
            this._steve.x = p3.View.width * 0.5;
            this._steve.y = this._base.y;
            this._steve.anchor = new PIXI.Point(0.5, 0.5);
            this._steve.visible = false;
            this.addChild(this._steve);

            this._jar = new PIXI.Sprite(assets.getTexture("splash_fg"));
            this._jar.x = p3.View.width * 0.5;
            this._jar.y = this._base.y;
            this._jar.anchor = new PIXI.Point(0.5, 0.5);
            this._jar.visible = false;
            this.addChild(this._jar);

            this._jar.light = new PIXI.Sprite(assets.getTexture("splash_fg_on"));
            this._jar.light.anchor = new PIXI.Point(0.5, 0.5);
            this._jar.light.visible = false;
            this._jar.addChild(this._jar.light);

            this._title = new PIXI.Sprite(assets.getTexture("title"));
            this._title.x = p3.View.width * 0.5;
            this._title.y = _Common2.default.STAGE_HEIGHT * 0.5 - 320;
            this._title.anchor = new PIXI.Point(0.5, 0.5);
            this._title.visible = false;
            this.addChild(this._title);

            var states = new p3.ButtonStates();
            states.normal = assets.getTexture("btn_small_off");
            states.icon = assets.getTexture("icon_home_off");

            this._homeButton = new p3.Button(states);
            this._homeButton.x = 100;
            this._homeButton.y = (_Common2.default.STAGE_HEIGHT - p3.View.height) * 0.5 + 100;
            this._homeButton.visible = false;
            this._homeButton.overSoundName = "sfx_btn_press_00";
            this._homeButton.clickSoundName = "sfx_btn_home_00";
            this._homeButton.signals.click.add(this.onHomeButtonClick, this);
            this.addChild(this._homeButton);

            states = new p3.ButtonStates();
            states.normal = assets.getTexture("btn_small_off");
            states.icon = assets.getTexture("icon_sound_off");
            states.iconAlt = assets.getTexture("icon_mute_off");

            this._muteButton = new p3.MuteButton(states);
            this._muteButton.x = p3.View.width - 100;
            this._muteButton.y = (_Common2.default.STAGE_HEIGHT - p3.View.height) * 0.5 + 100;
            this._muteButton.visible = false;
            this._muteButton.overSoundName = "sfx_btn_press_00";
            this._muteButton.clickSoundName = "sfx_btn_home_00";
            this.addChild(this._muteButton);

            states = new p3.ButtonStates();
            states.normal = assets.getTexture("btn_large_off");
            states.icon = assets.getTexture("icon_large_play_off");

            this._playButton = new p3.Button(states);
            this._playButton.x = p3.View.width * 0.5;
            this._playButton.y = _Common2.default.STAGE_HEIGHT * 0.5 + 380;
            this._playButton.visible = false;
            this._playButton.overSoundName = "sfx_btn_press_00";
            this._playButton.downSoundName = "sfx_btn_home_00";
            this._playButton.signals.click.add(this.onPlayButtonClick, this);
            this.addChild(this._playButton);
        }
    }, {
        key: "destroy",
        value: function destroy() {
            _get(SplashScene.prototype.__proto__ || Object.getPrototypeOf(SplashScene.prototype), "destroy", this).call(this);
        }
    }, {
        key: "appear",
        value: function appear() {
            _get(SplashScene.prototype.__proto__ || Object.getPrototypeOf(SplashScene.prototype), "appear", this).call(this);
        }

        /**
         * @param {function} [callback]
         * @param {*} [scope]
         */

    }, {
        key: "animateIn",
        value: function animateIn(callback, scope) {
            // home button
            /*
            this._homeButton.scale = new PIXI.Point();
            TweenMax.to(this._homeButton.scale, 0.34, {
                delay: 0.1,
                x: 1.0,
                y: 1.0,
                ease: Back.easeOut,
                easeParams: [2],
                onStart: function() {
                    this._homeButton.visible = true;
                },
                onStartScope: this
            });
            */

            // mute button
            this._muteButton.scale = new PIXI.Point();
            TweenMax.to(this._muteButton.scale, 0.34, {
                delay: 0.1,
                x: 1.0,
                y: 1.0,
                ease: Back.easeOut,
                easeParams: [2],
                onStart: function onStart() {
                    this._muteButton.visible = true;
                },
                onStartScope: this
            });

            // play button
            this._playButton.scale = new PIXI.Point();
            TweenMax.to(this._playButton.scale, 0.34, {
                x: 1.0,
                y: 1.0,
                ease: Back.easeOut,
                easeParams: [3],
                onStart: function onStart() {
                    this._playButton.visible = true;
                },
                onStartScope: this
            });

            // jar
            var to = this._jar.y;
            this._jar.y -= 80;
            this._jar.alpha = 0;
            TweenMax.to(this._jar, 0.34, {
                delay: 0.24,
                y: to,
                alpha: 1,
                ease: Power2.easeOut,
                onStart: function onStart() {
                    this._jar.visible = true;
                },
                onStartScope: this,
                onComplete: function onComplete() {
                    // light
                    this._jar.light.alpha = 0;
                    TweenMax.to(this._jar.light, 0.1, {
                        alpha: 1,
                        ease: Power2.easeInOut,
                        yoyo: true,
                        repeat: 1,
                        onStart: function onStart() {
                            this._jar.light.visible = true;
                            _Common2.default.audio.playSound("sfx_results_reveal_00");
                        },
                        onStartScope: this,
                        onComplete: function onComplete() {
                            this._jar.light.alpha = 1;
                        },
                        onCompleteScope: this
                    });
                },
                onCompleteScope: this
            });

            // steve
            to = this._steve.y;
            this._steve.y -= 80;
            this._steve.alpha = 0;
            TweenMax.to(this._steve, 0.34, {
                y: to,
                alpha: 1,
                ease: Power2.easeOut,
                onStart: function onStart() {
                    this._steve.visible = true;
                },
                onStartScope: this,
                onComplete: function onComplete() {
                    _Common2.default.audio.playSound("sfx_steve_00");
                }
            });

            // monitor left
            to = this._monitorLeft.x;
            this._monitorLeft.x -= 200;
            TweenMax.to(this._monitorLeft, 0.34, {
                delay: 0.2,
                x: to,
                ease: Power2.easeOut,
                onStart: function onStart() {
                    this._monitorLeft.visible = true;
                },
                onStartScope: this
            });

            // monitor right
            to = this._monitorRight.x;
            this._monitorRight.x += 200;
            TweenMax.to(this._monitorRight, 0.34, {
                delay: 0.2 + 0.1,
                x: to,
                ease: Power2.easeOut,
                onStart: function onStart() {
                    this._monitorRight.visible = true;
                },
                onStartScope: this
            });

            // title
            this._title.scale = new PIXI.Point();
            TweenMax.to(this._title.scale, 0.4, {
                delay: 0.34,
                x: 1,
                y: 1,
                ease: Back.easeOut,
                easeParams: [2],
                onStart: function onStart() {
                    this._title.visible = true;
                },
                onStartScope: this
            });
        }

        /**
         * @param {function} [callback]
         * @param {*} [scope]
         */

    }, {
        key: "animateOut",
        value: function animateOut(callback, scope) {}
    }, {
        key: "resize",
        value: function resize() {
            this.y = (p3.View.height - _Common2.default.STAGE_HEIGHT) * 0.5;
        }
    }, {
        key: "update",
        value: function update() {}

        /**
         * @param {p3.Button} button
         */

    }, {
        key: "onHomeButtonClick",
        value: function onHomeButtonClick(button) {}

        /**
         * @param {p3.Button} button
         */

    }, {
        key: "onPlayButtonClick",
        value: function onPlayButtonClick(button) {
            this.signals.next.dispatch(this);
        }
    }]);

    return SplashScene;
}(p3.Scene);

exports.default = SplashScene;

},{"./Common":11,"./ScanlinesFilter":24}],26:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
        value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _BaseTile2 = require("./BaseTile");

var _BaseTile3 = _interopRequireDefault(_BaseTile2);

var _Common = require("./Common");

var _Common2 = _interopRequireDefault(_Common);

var _ScanlinesFilter = require("./ScanlinesFilter");

var _ScanlinesFilter2 = _interopRequireDefault(_ScanlinesFilter);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /**
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *  Tile1
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *  Created by Legman on 13/03/2017.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */

/**
 * @class
 */
var Tile1 = function (_BaseTile) {
        _inherits(Tile1, _BaseTile);

        function Tile1() {
                _classCallCheck(this, Tile1);

                var assets = _Common2.default.assets;

                var _this = _possibleConstructorReturn(this, (Tile1.__proto__ || Object.getPrototypeOf(Tile1)).call(this, assets.getTexture("tile_001_bg")));

                _this._screens = new PIXI.Sprite(assets.getTexture("tile_001_screens"));
                _this.addChild(_this._screens);

                var filter = new _ScanlinesFilter2.default(_this._screens);
                _this._screens.filters = [filter];

                _this.view.anchor = new PIXI.Point();
                return _this;
        }

        _createClass(Tile1, [{
                key: "update",
                value: function update() {
                        _get(Tile1.prototype.__proto__ || Object.getPrototypeOf(Tile1.prototype), "update", this).call(this);

                        var filter = this._screens.filters[0];
                        filter.time -= deltaTime * 4;
                }
        }]);

        return Tile1;
}(_BaseTile3.default);

exports.default = Tile1;

},{"./BaseTile":8,"./Common":11,"./ScanlinesFilter":24}],27:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
        value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _BaseTile2 = require("./BaseTile");

var _BaseTile3 = _interopRequireDefault(_BaseTile2);

var _Common = require("./Common");

var _Common2 = _interopRequireDefault(_Common);

var _ScanlinesFilter = require("./ScanlinesFilter");

var _ScanlinesFilter2 = _interopRequireDefault(_ScanlinesFilter);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /**
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *  Tile2
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *  Created by Legman on 13/03/2017.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */

/**
 * @class
 */
var Tile2 = function (_BaseTile) {
        _inherits(Tile2, _BaseTile);

        function Tile2() {
                _classCallCheck(this, Tile2);

                var assets = _Common2.default.assets;

                var _this = _possibleConstructorReturn(this, (Tile2.__proto__ || Object.getPrototypeOf(Tile2)).call(this, assets.getTexture("tile_002_bg")));

                _this._screens = new PIXI.Sprite(assets.getTexture("tile_002_screens"));
                _this.addChild(_this._screens);

                var filter = new _ScanlinesFilter2.default(_this._screens);
                _this._screens.filters = [filter];

                _this.view.anchor = new PIXI.Point();
                return _this;
        }

        _createClass(Tile2, [{
                key: "update",
                value: function update() {
                        _get(Tile2.prototype.__proto__ || Object.getPrototypeOf(Tile2.prototype), "update", this).call(this);

                        var filter = this._screens.filters[0];
                        filter.time -= deltaTime * 4;
                }
        }]);

        return Tile2;
}(_BaseTile3.default);

exports.default = Tile2;

},{"./BaseTile":8,"./Common":11,"./ScanlinesFilter":24}],28:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
        value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _BaseTile2 = require("./BaseTile");

var _BaseTile3 = _interopRequireDefault(_BaseTile2);

var _Common = require("./Common");

var _Common2 = _interopRequireDefault(_Common);

var _ScanlinesFilter = require("./ScanlinesFilter");

var _ScanlinesFilter2 = _interopRequireDefault(_ScanlinesFilter);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /**
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *  Tile3
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *  Created by Legman on 13/03/2017.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */

/**
 * @class
 */
var Tile3 = function (_BaseTile) {
        _inherits(Tile3, _BaseTile);

        function Tile3() {
                _classCallCheck(this, Tile3);

                var assets = _Common2.default.assets;

                var _this = _possibleConstructorReturn(this, (Tile3.__proto__ || Object.getPrototypeOf(Tile3)).call(this, assets.getTexture("tile_003_bg")));

                _this._screens = new PIXI.Sprite(assets.getTexture("tile_003_screens"));
                _this.addChild(_this._screens);

                var filter = new _ScanlinesFilter2.default(_this._screens);
                _this._screens.filters = [filter];

                _this.view.anchor = new PIXI.Point();
                return _this;
        }

        _createClass(Tile3, [{
                key: "update",
                value: function update() {
                        _get(Tile3.prototype.__proto__ || Object.getPrototypeOf(Tile3.prototype), "update", this).call(this);

                        var filter = this._screens.filters[0];
                        filter.time -= deltaTime * 4;
                }
        }]);

        return Tile3;
}(_BaseTile3.default);

exports.default = Tile3;

},{"./BaseTile":8,"./Common":11,"./ScanlinesFilter":24}],29:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
        value: true
});

var _BaseTile2 = require("./BaseTile");

var _BaseTile3 = _interopRequireDefault(_BaseTile2);

var _Common = require("./Common");

var _Common2 = _interopRequireDefault(_Common);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /**
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *  TileBg1
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *  Created by Legman on 13/03/2017.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */

/**
 * @class
 */
var TileBg1 = function (_BaseTile) {
        _inherits(TileBg1, _BaseTile);

        function TileBg1() {
                _classCallCheck(this, TileBg1);

                var assets = _Common2.default.assets;

                var _this = _possibleConstructorReturn(this, (TileBg1.__proto__ || Object.getPrototypeOf(TileBg1)).call(this, assets.getTexture("tile_004")));

                _this.view.anchor = new PIXI.Point();

                var light = _this.createLight();
                light.y = _Common2.default.STAGE_HEIGHT * 0.5;
                return _this;
        }

        return TileBg1;
}(_BaseTile3.default);

exports.default = TileBg1;

},{"./BaseTile":8,"./Common":11}],30:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
        value: true
});

var _BaseTile2 = require("./BaseTile");

var _BaseTile3 = _interopRequireDefault(_BaseTile2);

var _Common = require("./Common");

var _Common2 = _interopRequireDefault(_Common);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /**
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *  TileBg2
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *  Created by Legman on 13/03/2017.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */

/**
 * @class
 */
var TileBg2 = function (_BaseTile) {
        _inherits(TileBg2, _BaseTile);

        function TileBg2() {
                _classCallCheck(this, TileBg2);

                var assets = _Common2.default.assets;

                var _this = _possibleConstructorReturn(this, (TileBg2.__proto__ || Object.getPrototypeOf(TileBg2)).call(this, assets.getTexture("tile_005")));

                _this.view.anchor = new PIXI.Point();

                var light = _this.createLight();
                light.x = _Common2.default.STAGE_WIDTH;
                light.y = _Common2.default.STAGE_HEIGHT * 0.5;
                light.scale.x = -1;
                return _this;
        }

        return TileBg2;
}(_BaseTile3.default);

exports.default = TileBg2;

},{"./BaseTile":8,"./Common":11}],31:[function(require,module,exports){
(function (global){
'use strict';

var _Main = require('./Main');

var _Main2 = _interopRequireDefault(_Main);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

global.Main = _Main2.default;

}).call(this,typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {})

},{"./Main":19}]},{},[31])

